import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Layout from "../../components/Layout.js";
import Select from "react-select";
import { apiFetch } from "../../api.js";

const ChallanDetailsDesign = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [BranchList, setBranchList] = useState([]);
  const [Branch, setBranch] = useState("");
  const [Challantype, setChallantype] = useState("Customer Challan");
  const [customerList, setCustomerList] = useState([]);
  const [customer, setCustomer] = useState("");
  const [title, setTitle] = useState("SELECT");
  const [ChallanDate, setChallanDate] = useState(
    new window.Date().toISOString().split("T")[0],
  );
  const [ChallanNo, setChallanNo] = useState("");
  const [Address, setAddress] = useState("");
  const [errors, setErrors] = useState({});
  const [StateList, setStateList] = useState([]);
  const [State, setState] = useState("");
  const [CityList, setCityList] = useState([]);
  const [City, setCity] = useState("");
  const [AreaList, setAreaList] = useState([]);
  const [Area, setArea] = useState("");
  const [showCityModal, setShowCityModal] = useState(false);
  const [newCityName, setNewCityName] = useState("");
  //const [newCityStateName, setNewCityStateName] = useState("");
  const [showAreaModal, setShowAreaModal] = useState(false);
  const [newAreaName, setNewAreaName] = useState("");
  const [newAreaCityName, setNewAreaCityName] = useState("");
  const [Location, setLocation] = useState("");
  const [MobileNo, setMobileNo] = useState("");
  const [Email, setEmail] = useState("");
  const [AadharNo, setAadharNo] = useState("");
  const [PanCard, setPanCard] = useState("");
  const [NomineeName, setNomineeName] = useState("");
  const [NomineeAge, setNomineeAge] = useState("");
  const [Relation, setRelation] = useState("");
  const [GST_No, setGST_No] = useState("");
  const [SC_Name, setSC_Name] = useState("");
  const [TL_Name, setTL_Name] = useState("");
  const [Model, setModel] = useState("");
  const [Modelunq, setModelunq] = useState("");
  const [varunq, setvarunq] = useState("");
  const [Variant, setVariant] = useState("");
  const [Color, setColor] = useState("");
  const [Engine_No, setEngine_No] = useState("");
  const [Specific_Code, setSpecific_Code] = useState("");
  const [Dispatch_By, setDispatch_By] = useState("");
  const [Driver_Name, setDriver_Name] = useState("");
  const [Search_to_transfer, setSearch_to_transfer] = useState("");
  const [Location_to_transfer, setLocation_to_transfer] = useState("");
  const [SC_Name_transfer, setSC_Name_transfer] = useState("");
  const [TCC_Incharge_Name, setTCC_Incharge_Name] = useState("");
  const [Manager, setManager] = useState("");
  const [VIN, setVIN] = useState("");
  const [Received_By, setReceived_By] = useState("");
  const [FinanceType, setFinanceType] = useState("Cash");
  const [HypothecationLessor, setHypothecationLessor] = useState("");
  const [FinanceBranchName, setFinanceBranchName] = useState("");
  const [showInsurance, setShowInsurance] = useState(false);
  const [InsuranceType, setInsuranceType] = useState("In House");
  const [InsuranceDiscount, setInsuranceDiscount] = useState("0.00");
  const [InsuranceExShowroom, setInsuranceExShowroom] = useState("0.00");
  const [AddEP, setAddEP] = useState(false);
  const [AddRTI, setAddRTI] = useState(false);
  const [AddCM, setAddCM] = useState(false);
  const [AddPB, setAddPB] = useState(false);
  const [AddKP, setAddKP] = useState(false);
  const [AddZD, setAddZD] = useState(false);
  const [AddNilDepreciation, setAddNilDepreciation] = useState(false);
  const [AddRoadSideAssistance, setAddRoadSideAssistance] = useState(false);
  const [AddEmiCover, setAddEmiCover] = useState(false);
  const [AddLoseOfIncome, setAddLoseOfIncome] = useState(false);
  const [AddConsumables, setAddConsumables] = useState(false);
  const [AddTowing, setAddTowing] = useState(false);
  const [AddEmergencyTransport, setAddEmergencyTransport] = useState(false);
  const [AddDailyAllowance, setAddDailyAllowance] = useState(false);
  const [AddTyreAndAllowCover, setAddTyreAndAllowCover] = useState(false);
  const [AddChargerProtection, setAddChargerProtection] = useState(false);
  const [AddBatteryCover, setAddBatteryCover] = useState(false);
  const [InsuranceCompany, setInsuranceCompany] = useState("");
  const [IDV, setIDV] = useState("0.00");
  const [IDVAmount, setIDVAmount] = useState("0.00");
  const [AfterIDV, setAfterIDV] = useState("0.00");
  const [InsurancePct, setInsurancePct] = useState("0.00");
  const [InsuranceAmount, setInsuranceAmount] = useState("0.00");
  const [DiscountAmount, setDiscountAmount] = useState("0.00");
  const [AfterDiscount, setAfterDiscount] = useState("0.00");
  const [CNGPct, setCNGPct] = useState("0.00");
  const [CNGAmount, setCNGAmount] = useState("0.00");
  const [PACover, setPACover] = useState("0");
  const [ZDPct, setZDPct] = useState("0.00");
  const [ZDAmount, setZDAmount] = useState("0.00");
  const [EPPct, setEPPct] = useState("0.00");
  const [EPAmount, setEPAmount] = useState("0.00");
  const [ThirdParty, setThirdParty] = useState("0.00");
  const [PBPct, setPBPct] = useState("0.00");
  const [KPAmount, setKPAmount] = useState("0.00");
  const [PaidDriver, setPaidDriver] = useState("0.00");
  const [AfterPD, setAfterPD] = useState("0.00");
  const [RTIPct, setRTIPct] = useState("0.00");
  const [RTIAmount, setRTIAmount] = useState("0.00");
  const [CMPct, setCMPct] = useState("0.00");
  const [CMAmount, setCMAmount] = useState("0.00");
  const [InsGST, setInsGST] = useState("18");
  const [InsCGST, setInsCGST] = useState("");
  const [InsSGST, setInsSGST] = useState("");
  const [InsGSTAmount, setInsGSTAmount] = useState("0.00");
  const [InsNCB, setInsNCB] = useState("0.00");
  const [InsNilDepreciation, setInsNilDepreciation] = useState("0.00");
  const [InsRoadSideAssistance, setInsRoadSideAssistance] = useState("0.00");
  const [InsFMICover, setInsFMICover] = useState("0.00");
  const [InsLossOfIncome, setInsLossOfIncome] = useState("0.00");
  const [InsConsumables, setInsConsumables] = useState("0.00");
  const [InsTowing, setInsTowing] = useState("0.00");
  const [InsDailyAllowance, setInsDailyAllowance] = useState("0.00");
  const [InsTyreAndAllowCover, setInsTyreAndAllowCover] = useState("0.00");
  const [InsEmergencyTransport, setInsEmergencyTransport] = useState("0.00");
  const [InsChargerProtection, setInsChargerProtection] = useState("0.00");
  const [InsBatteryCover, setInsBatteryCover] = useState("0.00");
  const [InsTotalAmount, setInsTotalAmount] = useState("0.00");
  const [showRTO, setShowRTO] = useState(false);
  const [RTOType, setRTOType] = useState("In House");
  const [LocalTaxApplicable, setLocalTaxApplicable] = useState(false);
  const [RTOExShowroom, setRTOExShowroom] = useState("0.00");
  const [VehiclePurchase, setVehiclePurchase] = useState("One");
  const [RTORate, setRTORate] = useState("0.00");
  const [RTOTaxSurcharge, setRTOTaxSurcharge] = useState("0.00");
  const [GreenTax, setGreenTax] = useState("0.00");
  const [RegFee, setRegFee] = useState("0.00");
  const [HPN, setHPN] = useState("0.00");
  const [Duplicate, setDuplicate] = useState("0.00");
  const [SmartCard, setSmartCard] = useState("0.00");
  const [Other, setOther] = useState("0.00");
  const [BHYear, setBHYear] = useState("");
  const [Vehiclecc, setVehiclecc] = useState("");
  const [FuelType, setFuelType] = useState("");
  const [RTOTemporary, setRTOTemporary] = useState("0.00");
  const [Scrappage, setScrappage] = useState(false);
  const [ScrappagePct, setScrappagePct] = useState("0.00");
  const [RTOAmount, setRTOAmount] = useState("0.00");
  const [MCDCharge, setMCDCharge] = useState("0");
  const [ExcludingTax, setExcludingTax] = useState("");
  const [OtherCharge, setOtherCharge] = useState("");
  const [RTOType2, setRTOType2] = useState("");
  const [NumberPlate, setNumberPlate] = useState("");
  const [RoadSafetyTax, setRoadSafetyTax] = useState("");
  const [RTOSurcharge, setRTOSurcharge] = useState("");
  const [CNGKitCharge, setCNGKitCharge] = useState("");
  const [VehicleCount, setVehicleCount] = useState("");
  const [LocalTax, setLocalTax] = useState("");
  const [showOthers, setShowOthers] = useState(false);
  const [OtherItem, setOtherItem] = useState("");
  const [OtherAmount, setOtherAmount] = useState("0.00");
  const [othersGrid, setOthersGrid] = useState([]);
  const [WorkshopINVNo, setWorkshopINVNo] = useState("");
  const [WorkshopINVAmt, setWorkshopINVAmt] = useState("0.00");
  const [RTOCity, setRTOCity] = useState("");
  const [RTOCityList, setRTOCityList] = useState([]);
  const [TRC, setTRC] = useState("0");
  const [CompanyAccessories, setCompanyAccessories] = useState("0.00");
  const [OwnAccessories, setOwnAccessories] = useState("0.00");
  const [AccessoriesAmount, setAccessoriesAmount] = useState("");
  const [Warranty, setWarranty] = useState("0.00");
  const [RSA, setRSA] = useState("0.00");
  const [SotType, setSotType] = useState("");
  const [SotAmount, setSotAmount] = useState("0.00");
  const [FastTag, setFastTag] = useState("0.00");
  const [TCS, setTCS] = useState("0.00");
  const [OtherTotal, setOtherTotal] = useState("0.00");
  const [paymentGrid] = useState([]);
  const [showRTOCityModal, setShowRTOCityModal] = useState(false);
  const [rtoModalCity, setRtoModalCity] = useState("");
  const [rtoModalMainCity, setRtoModalMainCity] = useState("");
  const [rtoCheckAll, setRtoCheckAll] = useState(false);
  const [insuranceCompanyList, setInsuranceCompanyList] = useState([]);

  const [rtoChecks, setRtoChecks] = useState({
    rtoRate: false,
    rtoTaxSurcharge: false,
    greenTax: false,
    regFee: false,
    hpn: false,
    duplicate: false,
    smartCard: false,
    other: false,
    trc: false,
  });
  const handleRtoCheckAll = (val) => {
    setRtoCheckAll(val);
    setRtoChecks(
      Object.fromEntries(Object.keys(rtoChecks).map((k) => [k, val])),
    );
  };
  const [showAccessoriesModal, setShowAccessoriesModal] = useState(false);
  const [accPartNo, setAccPartNo] = useState("");
  const [accOwnName, setAccOwnName] = useState("");
  const [accIssueQty, setAccIssueQty] = useState("");
  const [accRequiredQty, setAccRequiredQty] = useState("");
  const [accMrp, setAccMrp] = useState("");
  const [accQty, setAccQty] = useState("");
  const [accHMIAmount, setAccHMIAmount] = useState("");
  const [accOwnAmount, setAccOwnAmount] = useState("");
  const [accHMIDiscountAmount, setAccHMIDiscountAmount] = useState("");
  const [accHMITotalAmount, setAccHMITotalAmount] = useState("");
  const [accOWNAmount, setAccOWNAmount] = useState("");
  const [accOWNDiscountAmount, setAccOWNDiscountAmount] = useState("");
  const [accOWNTotalAmount, setAccOWNTotalAmount] = useState("");
  const [HPNReceivedAmt, setHPNReceivedAmt] = useState("0.00");
  const [CustomerReceivedAmt, setCustomerReceivedAmt] = useState("0.00");
  const [ReceivedAmt, setReceivedAmt] = useState("0.00");
  const [HPNBalance, setHPNBalance] = useState("0.00");
  const [CustomerBalance, setCustomerBalance] = useState("0.00");
  const [Balance, setBalance] = useState("0.00");
  const [Remark, setRemark] = useState("");
  const [ApprovalRemark, setApprovalRemark] = useState("");
  const [NetDisbursedAmount, setNetDisbursedAmount] = useState("0.00");
  const [LoanAmount, setLoanAmount] = useState("0.00");
  const [schemeTypeList, setSchemeTypeList] = useState([]);
  const [schemeType, setSchemeType] = useState("");
  const [schemeNameList, setSchemeNameList] = useState([]);
  const [schemeName, setSchemeName] = useState("");
  const [schemeAmount, setSchemeAmount] = useState("");
  const [schemeGrid, setSchemeGrid] = useState([]);
  const [Specialdiscount, setSpecialdiscount] = useState("");
  const [Exshowroom, setExshowroom] = useState("");
  const [Schemesless, setSchemesless] = useState("");
  const [Subtotal, setSubtotal] = useState("");
  const [hypothecationOptions, setHypothecationOptions] = useState([]);
  const [financeBranchOptions, setFinanceBranchOptions] = useState([]);

  // ================= MASTER CALCULATION FUNCTION =================
  const cal = () => {
    if (!customer) return;

    const num = (val) => parseFloat(val || 0);

    // ============================================================
    // BASIC VALUES
    // ============================================================
    const exShowroom   = num(Exshowroom);
    const schemeGridTotal = schemeGrid.reduce((sum, row) => sum + num(row.schemeAmount), 0);
    const specialDiscount = num(Specialdiscount);
    const schemeLess   = schemeGridTotal + specialDiscount;
    const accessories  = num(CompanyAccessories) + num(OwnAccessories);
    const workshop     = num(WorkshopINVAmt);
    const otherCharges = othersGrid.reduce((sum, item) => sum + num(item.otherAmount), 0);

    // ============================================================
    // SUBTOTAL  (txt_sp_503)
    // ============================================================
    const subtotal = exShowroom - schemeLess;
    setSchemesless(schemeLess.toFixed(2));
    setSubtotal(subtotal.toFixed(2));

    // ============================================================
    // TCS  (txt_sp_476)
    // ============================================================
    let tcsAmt = 0;
    if (subtotal > 1000000) {
      tcsAmt = Math.round(subtotal * num(TCS) / 100);
    }

    // ============================================================
    // RTO BASE  (txt_sp_549)
    // ============================================================
    let rtoBase = num(RTOExShowroom) > 0 ? num(RTOExShowroom) : exShowroom;

    // ============================================================
    // RTO AMOUNT  (txt_sp_500)
    // Old page: if (rtotype != "bh") { ... } else { BH logic }
    // ============================================================
    let rtoAmount = 0;
    const rtoType = RTOType; // "In House" | "Out House" | "BH"

    if (rtoType === "Out House" || rtoType === "out") {
      // Out House → RTO = 0
      rtoAmount = 0;

    } else if (rtoType === "BH" || rtoType === "bh") {
      // ---- BH calculation (old page BH block) ----
      const bhGstAfter = num(BHYear); // bhaftergstamt flag from API
      const bhRatePct  = num(RTORate);       // text_sp_636 → bhperc
      const bhYear     = num(BHYear);        // text_sp_637 → bhyear
      const bhPayYear  = 15;                 // bhpayear (default 15)
      const bhMultiple = 1.25;               // bhmultiplepa (default 1.25)

      const gstPct  = num(InsGST) || 18;
      const cessPct = 0; // cess not used in BH typically

      const others =
        num(GreenTax) + num(RegFee) + num(HPN) +
        num(Duplicate) + num(SmartCard) + num(Other) +
        num(RTOTemporary) + num(LocalTax) + num(MCDCharge);

      if (bhGstAfter) {
        // GST inclusive: taxable = rtoBase / (100 + gst) * 100
        const gst = gstPct + 100;
        const taxableAmt = (rtoBase / gst) * 100;
        const rtoAmt = Math.round(taxableAmt * bhRatePct / 100);
        const bhRto1 = (rtoAmt * bhYear * bhMultiple) / bhPayYear;
        rtoAmount = Math.round(bhRto1 + others);
      } else {
        // GST exclusive
        const cgst = gstPct / 2;
        const sgst = gstPct / 2;
        const gstAmt = cgst + sgst;
        const taxOnBH = (rtoBase / (100 + cessPct + gstAmt)) * 100;
        rtoAmount = Math.round(taxOnBH * bhRatePct / 100 * (bhMultiple / bhPayYear * bhYear));
        rtoAmount += others;
      }

    } else {
      // ---- In House calculation ----
      const scrappagePct = num(ScrappagePct);

      // Step 1: Scrappage reduces rtoBase (old: rtamt = rtamt * (100 - scrappage) / 100)
      if (Scrappage && scrappagePct > 0) {
        rtoBase = rtoBase * (100 - scrappagePct) / 100;
      }

      const rtoRate = (VehiclePurchase === "More than one" || VehiclePurchase === "MTL")
        ? num(RTOTaxSurcharge)  // secondrtorate for multiple vehicles
        : num(RTORate);

      // Step 2: Calculate rto tax on reduced base
      const rtoTax = rtoBase * rtoRate / 100;

      // Step 3: Scrappage deduction from rtoTax (old: scrappamt = rto * scrappage / 100; totalscrpamt = rto - scrappamt)
      const scrappageDeduct = Scrappage ? rtoTax * scrappagePct / 100 : 0;
      const rtoTaxAfterScrap = Math.round(rtoTax - scrappageDeduct);

      // surcharge on rtoTax
      const rtoSurchargeAmt = rtoTaxAfterScrap * num(RTOTaxSurcharge) / 100;

      // local tax
      const localTaxAmt = num(LocalTax);

      rtoAmount = Math.round(
        rtoSurchargeAmt +
        rtoTaxAfterScrap +
        num(GreenTax) +
        num(RegFee) +
        num(HPN) +
        num(Duplicate) +
        num(SmartCard) +
        num(Other) +
        num(RTOTemporary) +
        localTaxAmt
      );

      if (num(MCDCharge) > 0) {
        rtoAmount += num(MCDCharge);
      }
    }

    setRTOAmount(rtoAmount.toFixed(2));

    // ============================================================
    // INSURANCE  (txt_sp_520)
    // ============================================================
    let finalInsurance = 0;

    if (InsuranceType === "Out House" || InsuranceType === "out") {
      // Out House → all insurance fields = 0
      setIDVAmount("0.00");
      setAfterIDV("0.00");
      setInsuranceAmount("0.00");
      setDiscountAmount("0.00");
      setAfterDiscount("0.00");
      setCNGAmount("0.00");
      setInsCGST("0.00");
      setInsSGST("0.00");
      setInsGSTAmount("0.00");
      finalInsurance = 0;

    } else {
      // In House insurance calculation
      // Base: InsuranceExShowroom if set, else subtotal
      const insBase = num(InsuranceExShowroom) > 0 ? num(InsuranceExShowroom) : subtotal;

      // IDV
      const idvAmt = insBase * num(IDV) / 100;
      setIDVAmount(idvAmt.toFixed(2));

      const afterIdv = insBase - idvAmt;
      setAfterIDV(Math.round(afterIdv).toFixed(2));

      // OD (insurance %)
      const odAmt = afterIdv * num(InsurancePct) / 100;
      setInsuranceAmount(Math.round(odAmt).toFixed(2));

      // Discount on OD
      const discountAmt = odAmt * num(InsuranceDiscount) / 100;
      setDiscountAmount(Math.round(discountAmt).toFixed(2));

      const afterDiscount = odAmt - discountAmt;
      setAfterDiscount(Math.round(afterDiscount).toFixed(2));

      // ---- Add-ons ----
      let addonTotal = 0;

      // ZD, EP, RTI, CM → % of afterIdv
      if (AddZD)  addonTotal += afterIdv * num(ZDPct)  / 100;
      if (AddEP)  addonTotal += afterIdv * num(EPPct)  / 100;
      if (AddRTI) addonTotal += afterIdv * num(RTIPct) / 100;
      if (AddCM)  addonTotal += afterIdv * num(CMPct)  / 100;

      // KP: < 10 → %, else flat
      const kpVal = num(KPAmount);
      if (AddKP) addonTotal += kpVal < 10 ? (afterIdv * kpVal / 100) : kpVal;

      // PB → flat amount
      if (AddPB) addonTotal += num(PBPct);

      // Paid driver (flat)
      addonTotal += num(PaidDriver);

      // Third party + PA Cover (flat)
      addonTotal += num(ThirdParty) + num(PACover);

      // Fixed add-on amounts
      addonTotal +=
        num(InsNilDepreciation) +
        num(InsRoadSideAssistance) +
        num(InsFMICover) +
        num(InsLossOfIncome) +
        num(InsConsumables) +
        num(InsTowing) +
        num(InsDailyAllowance) +
        num(InsTyreAndAllowCover) +
        num(InsEmergencyTransport) +
        num(InsChargerProtection) +
        num(InsBatteryCover);

      // CNG % of afterDiscount
      const cngAmt = afterDiscount * num(CNGPct) / 100;
      setCNGAmount(cngAmt.toFixed(2));

      // Before GST = afterDiscount + addons + cng
      const beforeGST = afterDiscount + addonTotal + cngAmt;

      // GST split CGST + SGST
      const cgstPct = num(InsGST) / 2;
      const sgstPct = num(InsGST) / 2;
      const cgstAmt = beforeGST * cgstPct / 100;
      const sgstAmt = beforeGST * sgstPct / 100;
      const gstAmt  = cgstAmt + sgstAmt;

      setInsCGST(cgstAmt.toFixed(2));
      setInsSGST(sgstAmt.toFixed(2));
      setInsGSTAmount(Math.round(gstAmt).toFixed(2));

      finalInsurance = Math.round(beforeGST + gstAmt);
    }

    setInsTotalAmount(finalInsurance.toFixed(2));

    // ============================================================
    // GRAND TOTAL  (txt_sp_521)
    // Old: subtotal + fasttag + rsa + tcs + trc + accessories + warranty + rtoamt + insuranceamt + sot + others + workshop
    // ============================================================
    const grandTotal =
      subtotal +
      num(FastTag) +
      num(RSA) +
      tcsAmt +
      num(TRC) +
      accessories +
      num(Warranty) +
      rtoAmount +
      finalInsurance +
      num(SotAmount) +
      otherCharges +
      workshop;

    setOtherTotal(otherCharges.toFixed(2));
    setReceivedAmt(grandTotal.toFixed(2));

    // ============================================================
    // BALANCE
    // HPN Balance  = loanAmount - hpnReceived
    // Cust Balance = grandTotal - loanAmount - custReceived
    // ============================================================
    const hpnReceived  = num(HPNReceivedAmt);
    const custReceived = num(CustomerReceivedAmt);
    const loanAmt      = num(LoanAmount);

    const hpnDue  = loanAmt - hpnReceived;
    const custDue = grandTotal - loanAmt - custReceived;

    setHPNBalance(hpnDue.toFixed(2));
    setCustomerBalance(custDue.toFixed(2));
    setBalance((grandTotal - hpnReceived - custReceived).toFixed(2));
  };
  useEffect(() => {
    cal();
  }, [
    customer,
    Exshowroom,
    schemeGrid,
    Specialdiscount,

    CompanyAccessories,
    OwnAccessories,
    WorkshopINVAmt,
    othersGrid,
    FastTag,
    SotAmount,
    Warranty,
    RSA,

    RTOExShowroom,
    Scrappage,
    ScrappagePct,
    RTORate,
    RTOTaxSurcharge,
    VehiclePurchase,
    GreenTax,
    RegFee,
    HPN,
    Duplicate,
    SmartCard,
    Other,
    TRC,
    MCDCharge,
    RTOTemporary,
    LocalTax,
    RTOType,

    InsuranceExShowroom,
    InsuranceDiscount,
    IDV,
    InsurancePct,
    ThirdParty,
    PACover,

    AddZD, AddEP, AddRTI, AddCM, AddKP, AddPB,
    ZDPct, EPPct, RTIPct, CMPct, KPAmount, PBPct,
    PaidDriver,
    CNGPct,

    InsNilDepreciation,
    InsRoadSideAssistance,
    InsFMICover,
    InsLossOfIncome,
    InsConsumables,
    InsTowing,
    InsDailyAllowance,
    InsTyreAndAllowCover,
    InsEmergencyTransport,
    InsChargerProtection,
    InsBatteryCover,

    InsGST,
    InsuranceType,

    HPNReceivedAmt,
    CustomerReceivedAmt,
    LoanAmount,

    TCS,
  ]);
  // ------------------------HANDLE ADD CODE -------------------------
  const handleAddOther = () => {
    if (!OtherItem || !OtherAmount) {
      alert("Please select an item and enter an amount");
      return;
    }
    const newRow = {
      id: window.Date.now(),
      otherItem: OtherItem,
      otherAmount: parseFloat(OtherAmount || 0),
    };
    setOthersGrid([...othersGrid, newRow]);
    setOtherItem("");
    setOtherAmount("0.00");
  };
  // ------------------------HANDLE DELETE CODE -------------------------
  const handleDeleteOther = (id) => {
    setOthersGrid(othersGrid.filter((row) => row.id !== id));
  };
  // ------------------------STYLE SECTIONS -------------------------
  const customStyles = {
    control: (base) => ({
      ...base,
      minHeight: "40px",
      height: "40px",
      borderRadius: "6px",
      borderColor: "#ccc",
      boxShadow: "none",
    }),
    valueContainer: (base) => ({
      ...base,
      height: "40px",
      padding: "0 12px",
      display: "flex",
      alignItems: "center",
    }),
    indicatorsContainer: (base) => ({
      ...base,
      height: "40px",
    }),
    input: (base) => ({
      ...base,
      margin: 0,
      padding: 0,
    }),
  };

  const selectStyles = {
    control: (base, state) => ({
      ...base,
      minHeight: "42px",
      height: "42px",
      borderRadius: "8px",
      border: state.isFocused ? "1.5px solid #8B1E3F" : "1.5px solid #ddd",
      boxShadow: state.isFocused ? "0 0 0 3px rgba(139,30,63,.12)" : "none",
      background: state.isDisabled ? "#f5f5f5" : "#fafafa",
      transition: "border-color .2s, box-shadow .2s",
      "&:hover": { borderColor: "#8B1E3F" },
    }),
    valueContainer: (base) => ({
      ...base,
      height: "42px",
      padding: "0 12px",
      display: "flex",
      alignItems: "center",
    }),
    indicatorsContainer: (base) => ({ ...base, height: "42px" }),
    input: (base) => ({ ...base, margin: 0, padding: 0 }),
    placeholder: (base) => ({ ...base, color: "#aaa", fontSize: "13px" }),
    singleValue: (base) => ({
      ...base,
      color: "#333",
      fontSize: "14px",
      fontWeight: 500,
    }),
    indicatorSeparator: () => ({ display: "none" }),
    dropdownIndicator: (base) => ({ ...base, color: "#888" }),
    menu: (base) => ({ ...base, background: "#fff", backgroundColor: "#fff" }),
    menuList: (base) => ({
      ...base,
      background: "#fff",
      backgroundColor: "#fff",
    }),
    option: (base, state) => ({
      ...base,
      background: state.isSelected
        ? "#4a0e21"
        : state.isFocused
          ? "#6b1530"
          : "#fff",
      color: state.isSelected || state.isFocused ? "#fff" : "#333",
      fontSize: "14px",
    }),
    menuPortal: (base) => ({ ...base, zIndex: 999999 }),
  };

  const ChallanTypeOptions = [
    { value: "Customer Challan", label: "Customer Challan" },
    { value: "CSD Challan", label: "CSD Challan" },
    { value: "Inter Delear Challan", label: "Inter Delear Challan" },
    { value: "Lessee / Lessor", label: "Lessee / Lessor" },
    { value: "Stock to Branch", label: "Stock to Branch" },
    { value: "Used Car", label: "Used Car" },
  ];

  const titleOptions = [
    { value: "SELECT", label: "Select" },
    { value: "MR", label: "MR" },
    { value: "MRS", label: "MRS" },
    { value: "MISS", label: "MISS" },
    { value: "M/S", label: "M/S" },
  ];

  const relationOptions = [
    { value: "Choose Relationship", label: "Choose Relationship" },
    { value: "Mother", label: "Mother" },
    { value: "Father", label: "Father" },
    { value: "Daughter", label: "Daughter" },
    { value: "Son", label: "Son" },
    { value: "Sister", label: "Sister" },
    { value: "Husband", label: "Husband" },
    { value: "Wife", label: "Wife" },
    { value: "Brother", label: "Brother" },
    { value: "Friend", label: "Friend" },
  ];

  const selectPlaceholder = [{ value: "", label: "---Select---" }];
  const scNameOptions = [{ value: "", label: "Select" }];
  const dispatchOptions = [{ value: "", label: "---Select---" }];
  const branchTransferOptions = [{ value: "", label: "---Select---" }];
  const locationTransferOptions = [{ value: "", label: "---Select---" }];
  const technicianOptions = [{ value: "", label: "---Select---" }];

  // ------------------------HANDLE ADD SCHEME CODE -------------------------
  const handleAddScheme = () => {
    if (!schemeType || !schemeName || !schemeAmount) {
      alert("Please fill all scheme fields");
      return;
    }
    const selectedSchemeNameObj = schemeNameList.find(
      (o) => o.value === schemeName,
    );
    const newRow = {
      id: window.Date.now(),
      schemeType: schemeType,
      schemeName: selectedSchemeNameObj?.label || "",
      schemeAmount: parseFloat(schemeAmount || 0),
      schemeId: schemeName,
    };
    const updatedGrid = [...schemeGrid, newRow];
    setSchemeGrid(updatedGrid);
    const totalScheme = updatedGrid.reduce(
      (sum, row) => sum + parseFloat(row.schemeAmount || 0),
      0,
    );
    setSchemeType("");
    setSchemeName("");
    setSchemeAmount("0");
  };
  //------------------SCHEME DELETE BUTTON WORKING----------------------
  const handleDeleteScheme = (id) => {
    const updatedGrid = schemeGrid.filter((row) => row.id !== id);
    setSchemeGrid(updatedGrid);
    const totalScheme = updatedGrid.reduce(
      (sum, row) => sum + parseFloat(row.schemeAmount || 0),
      0,
    );
  };
  // ------------------------BRANCH DATA FETCH DATA -------------------------
  useEffect(() => {
    loadBranchList();
  }, []);
  const loadBranchList = async () => {
    try {
      const res = await apiFetch(
        "/api/challan/get-branch-list",
        {
          method: "POST",
        },
      );
      const data = await res.json();
      console.log("Branch API:", data);
      const options = (data || []).map((item) => ({
        value: item.data,
        label: item.value,
      }));
      setBranchList(options);
    } catch (err) {
      console.error("Branch load failed:", err);
      setBranchList([]);
    }
  };
  // ------------------------CUSTOMER NAME FETCH CODE -------------------------
  useEffect(() => {
    loadCustomerList("");
  }, []);
  const loadCustomerList = async (search = "") => {
    try {
      const res = await apiFetch(
        "/api/challan/get-customer-list",
        {
          method: "POST",
          body: JSON.stringify({ search }),
        },
      );
      const data = await res.json();
      const options = (data || []).map((item) => ({
        value: item.data,
        label: item.value,
        fullData: item,
      }));
      setCustomerList(options);
    } catch (err) {
      console.error("Customer load failed:", err);
      setCustomerList([]);
    }
  };
  useEffect(() => {
    loadChallanNo();
  }, []);
  const loadChallanNo = async () => {
    try {
      const res = await apiFetch(
        "/api/challan/get-challan-no",
        {
          method: "POST",
        },
      );

      const data = await res.json();
      console.log("Challan No API:", data);

      setChallanNo(data.challanNo || "");
    } catch (err) {
      console.error("Challan No load failed:", err);
      setChallanNo("");
    }
  };
  useEffect(() => {
    loadStateList();
  }, []);
  const loadStateList = async () => {
    try {
      const res = await apiFetch(
        "/api/challan/get-state-list",
        { method: "POST" },
      );
      const data = await res.json();

      const options = (data || []).map((item) => ({
        value: item.data,
        label: item.value,
      }));

      setStateList(options);
    } catch (err) {
      console.error("State load failed:", err);
      setStateList([]);
    }
  };
  const loadCityList = async (stateValue) => {
    try {
      const res = await apiFetch(
        "/api/challan/get-city-list",
        {
          method: "POST",
          body: JSON.stringify({ state: stateValue }),
        },
      );

      const data = await res.json();

      const options = (data || []).map((item) => ({
        value: item.data,
        label: item.value,
      }));

      setCityList(options);
    } catch (err) {
      console.error("City load failed:", err);
      setCityList([]);
    }
  };
  const loadAreaList = async (cityValue) => {
    try {
      const res = await apiFetch(
        "/api/challan/get-area-list",
        {
          method: "POST",
          body: JSON.stringify({ city: cityValue }),
        },
      );

      const data = await res.json();

      const options = (data || []).map((item) => ({
        value: item.data,
        label: item.value,
      }));

      setAreaList(options);
    } catch (err) {
      console.error("Area load failed:", err);
      setAreaList([]);
    }
  };
  const handleCitySave = async () => {
    if (!newCityName.trim()) {
      alert("Please enter city name");
      return;
    }

    try {
      const res = await apiFetch(
        "/api/booking/city/insert",
        {
          method: "POST",
          body: JSON.stringify({
            state: State, // ✅ FIXED
            city: newCityName,
          }),
        },
      );

      const data = await res.json();

      alert(data.message);

      setShowCityModal(false);
      setNewCityName("");

      // 🔥 reload city list
      await loadCityList(State);
    } catch (err) {
      console.error("City save failed:", err);
      alert("Failed to save city");
    }
  };
  const handleAreaSave = async () => {
    if (!newAreaName.trim()) {
      alert("Please enter area name");
      return;
    }

    if (!City) {
      alert("Please select city first");
      return;
    }

    try {
      const res = await apiFetch(
        "/api/booking/area/insert",
        {
          method: "POST",
          body: JSON.stringify({
            city: City, // ✅ UUID (important)
            area: newAreaName,
            zip: null, // optional
          }),
        },
      );

      const data = await res.json();

      alert(data.message);

      setShowAreaModal(false);
      setNewAreaName("");

      // 🔥 reload area list
      await loadAreaList(City);
    } catch (err) {
      console.error("Area save failed:", err);
      alert("Failed to save area");
    }
  };
  useEffect(() => {
    loadHPNList();
  }, []);

  const loadHPNList = async () => {
    try {
      const res = await apiFetch(
        "/api/challan/get-hpn-list",
        { method: "POST" },
      );

      const data = await res.json();

      const options = (data || []).map((item) => ({
        value: item.data,
        label: item.value,
      }));

      setHypothecationOptions(options);
    } catch (err) {
      console.error("HPN load failed:", err);
      setHypothecationOptions([]);
    }
  };
  const loadHPNBranchList = async (hpnId) => {
    try {
      const res = await apiFetch(
        "/api/challan/get-hpn-branch-list",
        {
          method: "POST",
          body: JSON.stringify({ hpnId }),
        },
      );

      const data = await res.json();

      const options = (data || []).map((item) => ({
        value: item.data,
        label: item.value,
      }));

      setFinanceBranchOptions(options);
    } catch (err) {
      console.error("HPN Branch load failed:", err);
      setFinanceBranchOptions([]);
    }
  };
  const loadSchemeType = async (modelid) => {
    try {
      const res = await apiFetch(
        "/api/challan/get-scheme-type",
        {
          method: "POST",
          body: JSON.stringify({ modelid }),
        },
      );

      const data = await res.json();

      setSchemeTypeList(data || []);
    } catch (err) {
      console.error("Scheme type load failed:", err);
      setSchemeTypeList([]);
    }
  };
  const loadSchemeName = async (modelid, schemetype) => {
    try {
      const res = await apiFetch(
        "/api/challan/get-scheme-name",
        {
          method: "POST",
          body: JSON.stringify({ modelid, schemetype }),
        },
      );

      const data = await res.json();

      setSchemeNameList(data || []);
    } catch (err) {
      console.error("Scheme name load failed:", err);
      setSchemeNameList([]);
    }
  };
  const loadSchemeAmount = async (schemeId, schemeType, model, variant) => {
    try {
      const res = await apiFetch(
        "/api/challan/get-scheme-amount",
        {
          method: "POST",
          body: JSON.stringify({
            schemeId, // exact backend key
            schemeType, // exact backend key
            model, // exact backend key
            variant, // exact backend key
          }),
        },
      );

      const data = await res.json();

      console.log("Scheme Amount API =>", data);

      setSchemeAmount(data.amt || "0");
    } catch (err) {
      console.error("Scheme amount load failed:", err);
      setSchemeAmount("0");
    }
  };
  // ============================================================
  // FRONTEND : ADD THIS BELOW loadSchemeAmount()
  // ============================================================
  const checkForDocket = async (custid, unqid = "") => {
    try {
      const res = await apiFetch(
        "/api/challan/check-customer-docket",
        {
          method: "POST",
          body: JSON.stringify({
            custid,
            unqid,
          }),
        },
      );

      const data = await res.json();

      console.log("CHECK FOR DOCKET RESPONSE =>", data);

      if (data.length > 0) {
        const loadedSchemeGrid = data.map((row, index) => ({
          id: window.Date.now() + index,
          schemeType: row.schemetype || "",
          schemeName: row.schemename || "",
          schemeAmount: parseFloat(row.schemeamt || 0),
          schemeId: row.schemeid || "",
        }));

        setSchemeGrid(loadedSchemeGrid);
      } else {
        setSchemeGrid([]);
      }
    } catch (err) {
      console.error("CHECK FOR DOCKET FAILED =>", err);
      setSchemeGrid([]);
    }
  };
  useEffect(() => {
    loadInsuranceCompanyList();
  }, []);

  const loadInsuranceCompanyList = async () => {
    try {
      const res = await apiFetch(
        "/api/challan/get-insurance-company-list",
        {
          method: "POST",
        },
      );

      const data = await res.json();

      console.log("Insurance Company API:", data);

      const options = (data || []).map((item) => ({
        value: item.data, // UUID
        label: item.value, // Company Name
        fullData: item,
      }));

      setInsuranceCompanyList(options);
    } catch (err) {
      console.error("Insurance Company load failed:", err);
      setInsuranceCompanyList([]);
    }
  };
  useEffect(() => {
    if (InsuranceCompany && ChallanDate && Modelunq) {
      loadInsuranceCalculation(InsuranceCompany, ChallanDate, Modelunq);
    }
  }, [InsuranceCompany, ChallanDate, Modelunq]);
  const loadInsuranceCalculation = async (
    insuranceId,
    challanDate,
    modelId,
  ) => {
    try {
      if (!insuranceId || !challanDate || !modelId) return;

      const res = await apiFetch(
        "/api/challan/get-insurance-calculation",
        {
          method: "POST",
          body: JSON.stringify({
            inscmpy: insuranceId,
            date: challanDate,
            model: modelId,
          }),
        },
      );

      const data = await res.json();

      console.log("Insurance Calculation Data =>", data);

      if (!data || Object.keys(data).length === 0) return;

      // Main Insurance Values
      setZDPct(data.sp_81_4 || "0.00");
      setZDAmount(data.sp_81_5 || "0.00");

      setEPPct(data.sp_81_6 || "0.00");
      setEPAmount(data.sp_81_7 || "0.00");

      setCMPct(data.sp_81_8 || "0.00");
      setCMAmount(data.sp_81_9 || "0.00");

      setRTIPct(data.sp_81_10 || "0.00");
      setRTIAmount(data.sp_81_11 || "0.00");

      setPBPct(data.sp_81_12 || "0.00");
      setKPAmount(data.sp_81_13 || "0.00");

      setPaidDriver(data.sp_81_15 || "0.00");

      setInsNCB(data.sp_81_36 || "0.00");

      setIDV(data.sp_81_38 || "0.00");
      setInsurancePct(data.sp_81_37 || "0.00");

      setThirdParty(data.sp_81_20 || "0.00");
      setPACover(data.sp_81_23 || "0.00");

      setCNGPct(data.sp_81_19 || "0.00");

      setInsGST(data.gst || "18");

      setInsuranceDiscount(data.sp_81_3 || "0.00");

      // Add-ons
      setInsNilDepreciation(data.sp_81_44 || "0.00");
      setInsRoadSideAssistance(data.sp_81_49 || "0.00");
      setInsFMICover(data.sp_81_46 || "0.00");
      setInsTyreAndAllowCover(data.sp_81_47 || "0.00");
      setInsLossOfIncome(data.sp_81_50 || "0.00");
      setInsDailyAllowance(data.sp_81_42 || "0.00");
      setInsConsumables(data.sp_81_43 || "0.00");
      setInsTowing(data.sp_81_48 || "0.00");
      setInsEmergencyTransport(data.sp_81_51 || "0.00");
      setInsChargerProtection(data.sp_81_41 || "0.00");
      setInsBatteryCover(data.sp_81_45 || "0.00");

      // Checkbox Logic
      setAddZD(Number(data.sp_81_5_1) === 1);
      setAddEP(Number(data.sp_81_7_1) === 1);
      setAddCM(Number(data.sp_81_9_1) === 1);
      setAddRTI(Number(data.sp_81_11_1) === 1);
      setAddKP(Number(data.sp_81_13_1) === 1);
      setAddPB(Number(data.sp_81_15_1) === 1);

      // Add-ons (amount based)
      setAddNilDepreciation(parseFloat(data.sp_81_44 || 0) > 0);
      setAddRoadSideAssistance(parseFloat(data.sp_81_49 || 0) > 0);
      setAddEmiCover(parseFloat(data.sp_81_46 || 0) > 0);
      setAddLoseOfIncome(parseFloat(data.sp_81_50 || 0) > 0);
      setAddConsumables(parseFloat(data.sp_81_43 || 0) > 0);
      setAddTowing(parseFloat(data.sp_81_48 || 0) > 0);
      setAddEmergencyTransport(parseFloat(data.sp_81_51 || 0) > 0);
      setAddDailyAllowance(parseFloat(data.sp_81_42 || 0) > 0);
      setAddTyreAndAllowCover(parseFloat(data.sp_81_47 || 0) > 0);
      setAddChargerProtection(parseFloat(data.sp_81_41 || 0) > 0);
      setAddBatteryCover(parseFloat(data.sp_81_45 || 0) > 0);
    } catch (err) {
      console.error("Insurance calculation load failed:", err);
    }
    cal();
  };
  useEffect(() => {
    if (Branch && ChallanDate && Exshowroom && Vehiclecc && State) {
      loadRTOCalculation();
    }
  }, [
    Branch,
    ChallanDate,
    Exshowroom,
    Vehiclecc,
    State,
    RTOType,
    VehiclePurchase,
  ]);
  const loadRTOCalculation = async (payload = null) => {
    try {
      const finalData = payload || {
        prefix: "CHALLAN",
        branchid: Branch,
        date: ChallanDate,
        exshowroom: Exshowroom,
        vehiclecc: Vehiclecc,
        rtostate: State,
        rtotype: RTOType === "In House" ? "in" : "out",
        vcount:
          VehiclePurchase === "ONL"
            ? "One"
            : VehiclePurchase === "MTL"
              ? "More than one"
              : VehiclePurchase,
        fuel: FuelType,
      };

      if (
        !finalData.branchid ||
        !finalData.date ||
        !finalData.exshowroom ||
        !finalData.vehiclecc ||
        !finalData.rtostate
      ) {
        console.log("RTO skipped due to missing fields:", finalData);
        return;
      }

      const res = await apiFetch(
        "/api/challan/get-rto-calculation",
        {
          method: "POST",
          body: JSON.stringify(finalData),
        },
      );

      const data = await res.json();

      console.log("RTO RESPONSE =>", data);

      if (data.length > 0) {
        const rto = data[0];

        setRTORate(
          finalData.vcount === "More than one"
            ? rto.secondrtorate || "0"
            : rto.rtorate || "0",
        );

        setRTOTaxSurcharge(rto.rtosurcharge || "0");
        setGreenTax(rto.greentax || "0");
        setRegFee(rto.regfee || "0");
        setHPN(rto.hpn || "0");
        setDuplicate(rto.duplicatecard || "0");
        setSmartCard(rto.smartcard || "0");
        setOther(rto.rtoother || "0");
        setBHYear(rto.bhrtoyear || "");
        setScrappage(
          rto.scrappage === true ||
            rto.scrappage === "True" ||
            rto.scrappage === "true",
        );
        // scrappage percentage value from API (hdn_scrappage in old page)
        const scrappageVal = parseFloat(rto.scrappage || 0);
        setScrappagePct(isNaN(scrappageVal) || scrappageVal === 1 ? "0.00" : (scrappageVal).toString());
        setMCDCharge(rto.mcdpkgcharge || "0");
        setExcludingTax(rto.excludingtax || "0");
        setOtherCharge(rto.othercharge || "0");
        setRTOType2(rto.type || "");
        setNumberPlate(rto.numberplate || "0");
        setRoadSafetyTax(rto.roadsafetytax || "0");
        setCNGKitCharge(rto.cngkitcharge || "0");
        setVehicleCount(rto.vehiclecount || "");
        setLocalTax(rto.localtax || rto.loacltax || "0");
      }
    } catch (err) {
      console.error("RTO LOAD FAILED =>", err);
    }
    cal();
  };
  useEffect(() => {
    const total =
      parseFloat(RTORate || 0) +
      parseFloat(RTOTaxSurcharge || 0) +
      parseFloat(GreenTax || 0) +
      parseFloat(RegFee || 0) +
      parseFloat(HPN || 0) +
      parseFloat(Duplicate || 0) +
      parseFloat(SmartCard || 0) +
      parseFloat(Other || 0) +
      parseFloat(NumberPlate || 0) +
      parseFloat(RoadSafetyTax || 0) +
      parseFloat(CNGKitCharge || 0) +
      parseFloat(LocalTax || 0);

    setRTOAmount(total.toFixed(2));
  }, [
    RTORate,
    RTOTaxSurcharge,
    GreenTax,
    RegFee,
    HPN,
    Duplicate,
    SmartCard,
    Other,
    NumberPlate,
    RoadSafetyTax,
    CNGKitCharge,
    LocalTax,
  ]);
  return (
    <Layout>
      <div className="ch-page">
        <div className="ch-card">
          {/* Header */}
          <div className="ch-header">
            <span className="ch-header-icon">📋</span>
            Challan
          </div>

          {/* Body */}
          <div className="ch-body">
            {/* Row 1 – Basic Info */}
            <div className="ch-grid ch-grid-4">
              <div className="ch-field">
                <label className="ch-label">Branch</label>
                <Select
                  classNamePrefix="rs"
                  options={BranchList}
                  getOptionLabel={(option) => option.label}
                  getOptionValue={(option) => option.value}
                  value={BranchList.find((o) => o.value === Branch) || null}
                  onChange={(selectedOption) => {
                    const selectedBranch = selectedOption?.value || "";

                    console.log("Selected =>", selectedOption);
                    console.log("Branch UUID =>", selectedBranch);

                    setBranch(selectedBranch);
                  }}
                  styles={selectStyles}
                  placeholder="Select Branch"
                  isSearchable
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                />
              </div>
              <div className="ch-field">
                <label className="ch-label">Challan Type</label>
                <Select
                  classNamePrefix="rs"
                  options={ChallanTypeOptions}
                  value={
                    ChallanTypeOptions.find((o) => o.value === Challantype) ||
                    null
                  }
                  onChange={(s) => setChallantype(s?.value || "")}
                  styles={selectStyles}
                  placeholder="Select Challan Type"
                  isSearchable={false}
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                />
              </div>
              <div className="ch-field">
                <label className="ch-label">Title</label>
                <Select
                  classNamePrefix="rs"
                  options={titleOptions}
                  value={titleOptions.find((o) => o.value === title)}
                  onChange={(s) => setTitle(s?.value || "SELECT")}
                  isSearchable={false}
                  styles={selectStyles}
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                />
              </div>
              <div className="ch-field">
                <label className="ch-label">Customer Name</label>
                <Select
                  classNamePrefix="rs"
                  options={customerList}
                  value={customerList.find((o) => o.value === customer) || null}
                  onInputChange={(inputValue) => {
                    if (inputValue.length >= 2) {
                      loadCustomerList(inputValue);
                    }
                  }}
                  onChange={async (s) => {
                    setCustomer(s?.value || "");

                    if (s?.fullData) {
                      const d = s.fullData;
                      console.log("FULL DATA KEYS =>", Object.keys(d));
                      console.log("FULL DATA =>", d);

                      // ================= BASIC DETAILS =================
                      setAddress(d.m1_11 || "");
                      setMobileNo(d.m1_47 || "");
                      setEmail(d.email || "");
                      setTitle(d.sp_54 || "SELECT");
                      setAadharNo(d.m1_48 || "");
                      setPanCard(d.m1_40 || "");
                      setGST_No(d.m1_37 || "");
                      setLocation(d.m1_50 || "");

                      // ================= VEHICLE =================
                      setModel(d.model || "");
                      setVariant(d.variant || "");
                      setvarunq(d.VA_27 || "");
                      setModelunq(d.VA_26 || "");

                      if (d.VA_26) {
                        await loadSchemeType(d.VA_26);
                      }

                      setColor(d.color || "");
                      setVIN(d.m1_51 || "");
                      setVehiclecc(d.vehiclecc || "");
                      setEngine_No(d.VA_29 || "");

                      // ================= STAFF =================
                      setSC_Name(d.scname || "");
                      setTL_Name(d.tlname || "");
                      setManager(d.manager || "");

                      // ================= LOCATION =================
                      // ================= LOCATION =================
                      setState(d.state || d.sp_774 || d.sp_772 || "");

                      if (d.state || d.sp_774 || d.sp_772) {
                        await loadCityList(d.state || d.sp_774 || d.sp_772);
                      }

                      setCity(d.cityunq || "");

                      if (d.cityunq) {
                        await loadAreaList(d.cityunq);
                      }

                      setArea(d.areaunq || "");

                      // ================= NOMINEE =================
                      setNomineeName(d.nominee || "");
                      setNomineeAge(d.age || "");
                      setRelation(d.relation || "");

                      // ================= FINANCE =================
                      setLoanAmount(d.loanamt || "0.00");
                      setNetDisbursedAmount(d.netdisbured || "0.00");
                      setHypothecationLessor(d.hpnunq || "");
                      setFinanceBranchName(d.branchid || "");
                      if (d.hpnunq) {
                        await loadHPNBranchList(d.hpnunq);
                      }

                      // ================= INSURANCE =================
                      setInsuranceDiscount(d.insdis || "0");
                      setInsuranceType(d.insinout || "In House");
                      setInsuranceCompany(d.inscmpyid || "");
                      setWarranty(d.wrty_amt || d.warranty || "0.00");
                      setAddEP(d.ep === "1" || d.ep === 1 || d.ep === true);
                      setAddRTI(d.rti === "1" || d.rti === 1 || d.rti === true);
                      setAddCM(d.cm === "1" || d.cm === 1 || d.cm === true);

                      // ================= RTO =================
                      // ================= RTO =================
                      setRTOCity(d.rtocity || "");
                      setTRC(d.trc || "0");
                      setRTOType(d.rtoinout || "In House");
                      setFuelType(d.fuel || "");

                      // ================= SOT =================
                      setSotType(d.sot || "");
                      setSotAmount(d.sot_amt || "0.00");

                      // ================= PRICING =================
                      setExshowroom(d.exshowroom || d.exshowroom || "0.00");
                      setInsuranceExShowroom(
                        d.exshowroom ||
                          d.EXSHOWROOM ||
                          d.ExShowroom ||
                          d.ex_showroom ||
                          "0.00",
                      );
                      setRTOExShowroom(
                        d.exshowroom ||
                          d.EXSHOWROOM ||
                          d.ExShowroom ||
                          d.ex_showroom ||
                          "0.00",
                      );
                      setRSA(d.rsa || "0.00");
                      setFastTag(d.sp_775 || "0.00");
                      setTCS(d.tcscal || "0.00");
                      setCompanyAccessories(d.ot_cap1 || "0.00");
                      setOwnAccessories(d.ot_cap2 || "0.00");

                      // ================= SCHEME GRID =================
                      if (d.scheme) {
                        const schemeRows = Array.isArray(d.scheme)
                          ? d.scheme
                          : [
                              {
                                schemeType: d.scheme,
                                schemeName: d.loyality || d.dealer || "",
                                schemeAmount: parseFloat(d.sot_amt || 0),
                              },
                            ];
                        setSchemeGrid(
                          schemeRows.map((sr, i) => ({
                            id: window.Date.now() + i,
                            schemeType: sr.schemeType || sr.scheme || "",
                            schemeName:
                              sr.schemeName || sr.loyality || sr.dealer || "",
                            schemeAmount: parseFloat(
                              sr.schemeAmount || sr.sot_amt || 0,
                            ),
                            schemeId: sr.schemeId || "",
                          })),
                        );
                      }

                      // ================= OTHERS GRID =================
                      const othersFromData = [];
                      if (d.ot_cap1 && parseFloat(d.ot_cap1) > 0) {
                        othersFromData.push({
                          id: window.Date.now() + 1,
                          otherItem: d.ot_cap1 || "Company Accessories",
                          otherAmount: parseFloat(d.ot_amt1 || 0),
                        });
                      }
                      if (d.ot_cap2 && parseFloat(d.ot_cap2) > 0) {
                        othersFromData.push({
                          id: window.Date.now() + 2,
                          otherItem: d.ot_cap2 || "Own Accessories",
                          otherAmount: parseFloat(d.ot_amt2 || 0),
                        });
                      }
                      if (d.ot_cap3 && parseFloat(d.ot_cap3) > 0) {
                        othersFromData.push({
                          id: window.Date.now() + 3,
                          otherItem: d.ot_cap3 || "Other",
                          otherAmount: parseFloat(d.ot_amt3 || 0),
                        });
                      }
                      if (othersFromData.length > 0)
                        setOthersGrid(othersFromData);
                      // ================= RTO CALCULATION (call directly with fresh values) =================
                      const rtoExshowroom =
                        d.exshowroom ||
                        d.EXSHOWROOM ||
                        d.ExShowroom ||
                        d.ex_showroom ||
                        "0";
                      const rtoVehiclecc = d.vehiclecc || "0";
                      const rtoState = d.state || d.sp_774 || d.sp_772 || "";
                      const rtoType =
                        (d.rtoinout || "In House") === "In House"
                          ? "in"
                          : "out";
                      const rtoFuel = d.fuel || "";
                      const rtoBranch = d.branchid || Branch;
                      const rtoDate =
                        ChallanDate ||
                        new window.Date().toISOString().split("T")[0];

                      if (
                        rtoBranch &&
                        rtoDate &&
                        rtoExshowroom &&
                        rtoExshowroom !== "0" &&
                        rtoVehiclecc &&
                        rtoState
                      ) {
                        await loadRTOCalculation({
                          prefix: "CHALLAN",
                          branchid: rtoBranch,
                          date: rtoDate,
                          exshowroom: rtoExshowroom,
                          vehiclecc: rtoVehiclecc,
                          rtostate: rtoState,
                          rtotype: rtoType,
                          vcount: "One",
                          fuel: rtoFuel,
                        });
                      } else {
                        console.log("RTO skipped — missing:", {
                          rtoBranch,
                          rtoDate,
                          rtoExshowroom,
                          rtoVehiclecc,
                          rtoState,
                        });
                      }

                      await checkForDocket(
                        s.value,
                        location.state?.unqid || "",
                      );

                      // ================= INSURANCE CALCULATION =================
                      const insCompany = d.inscmpyid || "";
                      const insDate = ChallanDate || new window.Date().toISOString().split("T")[0];
                      const insModel = d.VA_26 || "";
                      if (insCompany && insDate && insModel) {
                        await loadInsuranceCalculation(insCompany, insDate, insModel);
                      }
                    } else {
                      setSchemeGrid([]);
                    }
                  }}
                  placeholder="Search Customer"
                  isSearchable
                  styles={selectStyles}
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                />
              </div>
            </div>

            {/* Row 2 – Challan Details */}
            <div className="ch-grid ch-grid-3w">
              <div className="ch-field">
                <label className="ch-label">Date</label>
                <input
                  type="date"
                  className="ch-input"
                  value={ChallanDate}
                  onChange={(e) => setChallanDate(e.target.value)}
                />
              </div>
              <div className="ch-field">
                <label className="ch-label">Challan No</label>
                <input
                  type="number"
                  className="ch-input ch-readonly"
                  value={ChallanNo}
                  readOnly
                />
              </div>
              <div className="ch-field ch-col-wide">
                <label className="ch-label">Address</label>
                <input
                  type="text"
                  className="ch-input"
                  value={Address}
                  placeholder="Enter Address"
                  onChange={(e) => setAddress(e.target.value)}
                />
              </div>
            </div>

            {/* Row 3 – Location */}
            <div className="ch-grid ch-grid-3">
              <div className="ch-field">
                <label className="ch-label">State</label>
                <Select
                  classNamePrefix="rs"
                  options={StateList || []}
                  getOptionLabel={(option) => option.label}
                  getOptionValue={(option) => option.value}
                  value={
                    StateList.find((o) => String(o.value) === String(State)) ||
                    null
                  }
                  onChange={(selectedOption) => {
                    const selectedState = selectedOption?.value || "";

                    console.log("Selected State Object =>", selectedOption);
                    console.log("Selected State UUID =>", selectedState);

                    setState(selectedState);

                    setCity("");
                    setArea("");
                    setCityList([]);
                    setAreaList([]);

                    if (selectedState) {
                      loadCityList(selectedState);
                    }
                    loadRTOCalculation();
                  }}
                  styles={selectStyles}
                  placeholder="Select State"
                  isSearchable
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                />
              </div>
              <div className="ch-field">
                <label className="ch-label">City</label>
                <div className="ch-with-btn">
                  <Select
                    classNamePrefix="rs"
                    options={CityList}
                    value={CityList.find((c) => c.value === City) || null}
                    onChange={(s) => {
                      const val = s?.value || "";

                      setCity(val);

                      // 🔥 RESET AREA
                      setArea("");
                      setAreaList([]);

                      // 🔥 LOAD AREA
                      if (val) loadAreaList(val);
                    }}
                    placeholder="Select City"
                    styles={selectStyles}
                    isSearchable
                    isDisabled={!State}
                  />
                  <button
                    type="button"
                    className="ch-add-btn"
                    onClick={() => {
                      if (!State) {
                        alert("Please select state first");
                        return;
                      }
                      setShowCityModal(true);
                    }}
                  >
                    +
                  </button>
                </div>
              </div>
              <div className="ch-field">
                <label className="ch-label">Area</label>
                <div className="ch-with-btn">
                  <Select
                    classNamePrefix="rs"
                    options={AreaList}
                    value={AreaList.find((a) => a.value === Area) || null}
                    onChange={(s) => setArea(s?.value || "")}
                    placeholder="Select Area"
                    styles={selectStyles}
                    isSearchable
                    isDisabled={!City}
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                  />
                  <button
                    type="button"
                    className="ch-add-btn"
                    onClick={() => {
                      if (!City) {
                        alert("Please select city first");
                        return;
                      }
                      setShowAreaModal(true);
                    }}
                  >
                    +
                  </button>
                </div>
              </div>
            </div>

            {/* Row 4 – Contact */}
            <div className="ch-grid ch-grid-4">
              <div className="ch-field">
                <label className="ch-label">Location</label>
                <input
                  type="text"
                  className="ch-input"
                  value={Location}
                  placeholder="Enter Location"
                  maxLength="3"
                  onChange={(e) =>
                    setLocation(e.target.value.replace(/[^0-9]/g, ""))
                  }
                />
              </div>
              <div className="ch-field">
                <label className="ch-label">Mobile No</label>
                <input
                  type="text"
                  className="ch-input"
                  value={MobileNo}
                  placeholder="Enter Mobile No"
                  maxLength="10"
                  onChange={(e) =>
                    setMobileNo(e.target.value.replace(/[^0-9]/g, ""))
                  }
                />
              </div>
              <div className="ch-field">
                <label className="ch-label">Email</label>
                <input
                  type="email"
                  className="ch-input"
                  value={Email}
                  placeholder="Enter Email"
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <div className="ch-field">
                <label className="ch-label">Aadhar No</label>
                <input
                  type="text"
                  className="ch-input"
                  value={AadharNo}
                  placeholder="Enter Aadhar No"
                  maxLength="12"
                  onChange={(e) =>
                    setAadharNo(e.target.value.replace(/[^0-9]/g, ""))
                  }
                />
              </div>
            </div>

            {/* Row 5 – Nominee Details */}

            <div className="ch-grid ch-grid-4">
              <div className="ch-field">
                <label className="ch-label">Pan Card</label>
                <input
                  type="text"
                  className="ch-input"
                  value={PanCard}
                  placeholder="Enter Pan Card No"
                  maxLength="10"
                  onChange={(e) =>
                    setPanCard(
                      e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, ""),
                    )
                  }
                />
              </div>
              <div className="ch-field">
                <label className="ch-label">Nominee Name</label>
                <input
                  type="text"
                  className="ch-input"
                  value={NomineeName}
                  placeholder="Enter Nominee Name"
                  onChange={(e) =>
                    setNomineeName(e.target.value.replace(/[^a-zA-Z ]/g, ""))
                  }
                />
              </div>
              <div className="ch-field">
                <label className="ch-label">Age</label>
                <input
                  type="text"
                  className="ch-input"
                  value={NomineeAge}
                  placeholder="Enter Age"
                  maxLength="3"
                  onChange={(e) =>
                    setNomineeAge(e.target.value.replace(/[^0-9]/g, ""))
                  }
                />
              </div>
              <div className="ch-field">
                <label className="ch-label">Relation</label>
                <Select
                  classNamePrefix="rs"
                  options={relationOptions}
                  value={
                    relationOptions.find((o) => o.value === Relation) || null
                  }
                  onChange={(s) => setRelation(s?.value || "")}
                  styles={selectStyles}
                  placeholder="Choose Relationship"
                  isSearchable={false}
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                />
              </div>
            </div>

            {/* Row 6 – GST / SC Name / TL Name / Manager */}
            <div className="ch-grid ch-grid-4">
              <div className="ch-field">
                <label className="ch-label">GST No</label>
                <input
                  type="text"
                  className="ch-input"
                  value={GST_No}
                  placeholder="Enter GST No"
                  onChange={(e) => setGST_No(e.target.value.toUpperCase())}
                />
              </div>
              <div className="ch-field">
                <label className="ch-label">SC Name</label>
                <input
                  type="text"
                  className="ch-input"
                  value={SC_Name}
                  placeholder="Enter SC Name"
                  onChange={(e) =>
                    setSC_Name(e.target.value.replace(/[^a-zA-Z ]/g, ""))
                  }
                />
              </div>
              <div className="ch-field">
                <label className="ch-label">TL Name</label>
                <input
                  type="text"
                  className="ch-input"
                  value={TL_Name}
                  placeholder="Enter TL Name"
                  onChange={(e) =>
                    setTL_Name(e.target.value.replace(/[^a-zA-Z ]/g, ""))
                  }
                />
              </div>
              <div className="ch-field">
                <label className="ch-label">Manager</label>
                <input
                  type="text"
                  className="ch-input"
                  value={Manager}
                  placeholder="Enter Manager Name"
                  onChange={(e) =>
                    setManager(e.target.value.replace(/[^a-zA-Z ]/g, ""))
                  }
                />
              </div>
            </div>

            {/* Row 7 – Model / Variant / Color / VIN */}
            <div className="ch-grid ch-grid-4">
              <div className="ch-field">
                <label className="ch-label">Model</label>
                <input
                  type="text"
                  className="ch-input"
                  value={Model}
                  placeholder="Enter Model"
                  onChange={(e) => setModel(e.target.value)}
                />
              </div>
              <div className="ch-field">
                <label className="ch-label">Variant</label>
                <input
                  type="text"
                  className="ch-input"
                  value={Variant}
                  placeholder="Enter Variant"
                  onChange={(e) => setVariant(e.target.value)}
                />
              </div>
              <div className="ch-field">
                <label className="ch-label">Color</label>
                <input
                  type="text"
                  className="ch-input"
                  value={Color}
                  placeholder="Enter Color"
                  onChange={(e) =>
                    setColor(e.target.value.replace(/[^a-zA-Z ]/g, ""))
                  }
                />
              </div>
              <div className="ch-field">
                <label className="ch-label">VIN</label>
                <input
                  type="text"
                  className="ch-input"
                  value={VIN}
                  placeholder="Enter VIN"
                  onChange={(e) => setVIN(e.target.value.toUpperCase())}
                />
              </div>
            </div>

            {/* Row 8 – Engine No / Specific Code / Dispatch By / Received By */}
            <div className="ch-grid ch-grid-4">
              <div className="ch-field">
                <label className="ch-label">Engine No</label>
                <input
                  type="text"
                  className="ch-input"
                  value={Engine_No}
                  placeholder="Enter Engine No"
                  onChange={(e) => setEngine_No(e.target.value.toUpperCase())}
                />
              </div>
              <div className="ch-field">
                <label className="ch-label">Specific Code</label>
                <input
                  type="text"
                  className="ch-input"
                  value={Specific_Code}
                  placeholder="Enter Specific Code"
                  onChange={(e) =>
                    setSpecific_Code(e.target.value.toUpperCase())
                  }
                />
              </div>
              <div className="ch-field">
                <label className="ch-label">Dispatch By</label>
                <Select
                  classNamePrefix="rs"
                  options={dispatchOptions}
                  value={
                    dispatchOptions.find((o) => o.value === Dispatch_By) || null
                  }
                  onChange={(s) => setDispatch_By(s?.value || "")}
                  styles={selectStyles}
                  placeholder="---Select---"
                  isDisabled={true}
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                />
              </div>
              <div className="ch-field">
                <label className="ch-label">Received By</label>
                <Select
                  classNamePrefix="rs"
                  options={selectPlaceholder}
                  value={
                    selectPlaceholder.find((o) => o.value === Received_By) ||
                    null
                  }
                  onChange={(s) => setReceived_By(s?.value || "")}
                  styles={selectStyles}
                  placeholder="---Select---"
                  isDisabled={true}
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                />
              </div>
            </div>

            {/* Row 9 – Driver Name / Branch to Transfer / Location to Transfer / Technician Name */}
            <div className="ch-grid ch-grid-4">
              <div className="ch-field">
                <label className="ch-label">Driver Name</label>
                <Select
                  classNamePrefix="rs"
                  options={selectPlaceholder}
                  value={
                    selectPlaceholder.find((o) => o.value === Driver_Name) ||
                    null
                  }
                  onChange={(s) => setDriver_Name(s?.value || "")}
                  styles={selectStyles}
                  placeholder="---Select---"
                  isDisabled={true}
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                />
              </div>
              <div className="ch-field">
                <label className="ch-label">Branch to Transfer</label>
                <Select
                  classNamePrefix="rs"
                  options={branchTransferOptions}
                  value={
                    branchTransferOptions.find(
                      (o) => o.value === Search_to_transfer,
                    ) || null
                  }
                  onChange={(s) => setSearch_to_transfer(s?.value || "")}
                  styles={selectStyles}
                  placeholder="---Select---"
                  isDisabled={true}
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                />
              </div>
              <div className="ch-field">
                <label className="ch-label">Location to Transfer</label>
                <Select
                  classNamePrefix="rs"
                  options={locationTransferOptions}
                  value={
                    locationTransferOptions.find(
                      (o) => o.value === Location_to_transfer,
                    ) || null
                  }
                  onChange={(s) => setLocation_to_transfer(s?.value || "")}
                  styles={selectStyles}
                  placeholder="---Select---"
                  isDisabled={true}
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                />
              </div>
              <div className="ch-field">
                <label className="ch-label">Technician Name</label>
                <Select
                  classNamePrefix="rs"
                  options={technicianOptions}
                  value={
                    technicianOptions.find(
                      (o) => o.value === TCC_Incharge_Name,
                    ) || null
                  }
                  onChange={(s) => setTCC_Incharge_Name(s?.value || "")}
                  styles={selectStyles}
                  placeholder="---Select---"
                  isDisabled={true}
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                />
              </div>
            </div>

            {/* Row 10 – SC Name (select) */}
            <div className="ch-grid ch-grid-4">
              <div className="ch-field">
                <label className="ch-label">Sc Name</label>
                <Select
                  classNamePrefix="rs"
                  options={scNameOptions}
                  value={
                    scNameOptions.find((o) => o.value === SC_Name_transfer) ||
                    null
                  }
                  onChange={(s) => setSC_Name_transfer(s?.value || "")}
                  styles={selectStyles}
                  placeholder="Select"
                  isDisabled={true}
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                />
              </div>
            </div>

            {/* ── Finance Section ── */}
            <div className="ch-section-label">Finance</div>

            {/* Finance Type / Hypothecation / Branch Name */}
            <div className="ch-grid ch-grid-3">
              <div className="ch-field">
                <label className="ch-label">Finance</label>
                <div className="ch-radio-group">
                  <label className="ch-radio-label">
                    <input
                      type="radio"
                      name="financeType"
                      value="In House"
                      checked={FinanceType === "In House"}
                      onChange={() => setFinanceType("In House")}
                    />
                    <span>In House</span>
                  </label>
                  <label className="ch-radio-label">
                    <input
                      type="radio"
                      name="financeType"
                      value="Out House"
                      checked={FinanceType === "Out House"}
                      onChange={() => setFinanceType("Out House")}
                    />
                    <span>Out House</span>
                  </label>
                  <label className="ch-radio-label">
                    <input
                      type="radio"
                      name="financeType"
                      value="Cash"
                      checked={FinanceType === "Cash"}
                      onChange={() => setFinanceType("Cash")}
                    />
                    <span>Cash</span>
                  </label>
                </div>
              </div>
              <div className="ch-field">
                <label className="ch-label">Hypothecation / Lessor</label>
                <Select
                  options={hypothecationOptions}
                  value={
                    hypothecationOptions.find(
                      (o) => o.value === HypothecationLessor,
                    ) || null
                  }
                  onChange={(s) => {
                    const val = s?.value || "";

                    setHypothecationLessor(val);

                    // 🔥 reset branch
                    setFinanceBranchName("");
                    setFinanceBranchOptions([]);

                    // 🔥 load branch
                    if (val) loadHPNBranchList(val);
                  }}
                />
              </div>
              <div className="ch-field">
                <label className="ch-label">Branch Name</label>
                <Select
                  options={financeBranchOptions}
                  value={
                    financeBranchOptions.find(
                      (o) => o.value === FinanceBranchName,
                    ) || null
                  }
                  onChange={(s) => setFinanceBranchName(s?.value || "")}
                />
              </div>
            </div>

            {/* Net Disbursed Amount / Loan Amount */}
            <div className="ch-grid ch-grid-4" style={{ marginTop: "16px" }}>
              <div className="ch-field">
                <label className="ch-label">Net Disbursed Amount</label>
                <input
                  type="text"
                  className="ch-input ch-amount-input"
                  value={NetDisbursedAmount}
                  onChange={(e) =>
                    setNetDisbursedAmount(
                      e.target.value.replace(/[^0-9.]/g, ""),
                    )
                  }
                />
              </div>
              <div className="ch-field">
                <label className="ch-label">Loan Amount</label>
                <input
                  type="text"
                  className="ch-input ch-amount-input"
                  value={LoanAmount}
                  onChange={(e) =>
                    setLoanAmount(e.target.value.replace(/[^0-9.]/g, ""))
                  }
                />
              </div>
            </div>
            <div className="ch-section-label"> Scheme Detail</div>
            <div
              className="ch-grid ch-grid-4"
              style={{ alignItems: "flex-end" }}
            >
              <div className="ch-field">
                <label className="ch-label">Scheme Type</label>
                <Select
                  classNamePrefix="rs"
                  options={schemeTypeList}
                  value={
                    schemeTypeList.find((o) => o.value === schemeType) || null
                  }
                  onChange={(s) => {
                    const val = s?.value || "";

                    setSchemeType(val);

                    // Reset child dropdown
                    setSchemeName("");
                    setSchemeNameList([]);

                    // Load Scheme Names
                    if (val && Modelunq) {
                      loadSchemeName(Modelunq, val);
                    }
                  }}
                  styles={selectStyles}
                  placeholder="Select"
                  isSearchable
                />
              </div>

              <div className="ch-field">
                <label className="ch-label">Scheme Name</label>
                <Select
                  classNamePrefix="rs"
                  options={schemeNameList}
                  value={
                    schemeNameList.find((o) => o.value === schemeName) || null
                  }
                  onChange={(s) => {
                    const val = s?.value || "";

                    setSchemeName(val);

                    if (val && schemeType && Modelunq && varunq) {
                      loadSchemeAmount(val, schemeType, Modelunq, varunq);
                    } else {
                      setSchemeAmount("0");
                    }
                  }}
                  styles={selectStyles}
                  placeholder="Select"
                  isSearchable
                />
              </div>

              <div className="ch-field">
                <label className="ch-label">Scheme Amount</label>
                <input
                  className="ch-input ch-amount-input"
                  value={schemeAmount}
                  onChange={(e) => setSchemeAmount(e.target.value)}
                  placeholder="0"
                />
              </div>

              <div className="ch-field">
                <button
                  className="next-btn-imd"
                  style={{ background: "#28a745", marginTop: "22px" }}
                  onClick={handleAddScheme}
                >
                  + Add Scheme
                </button>
              </div>
            </div>
            {schemeGrid.length > 0 && (
              <div
                style={{
                  marginTop: "16px",
                  borderRadius: "8px",
                  overflow: "hidden",
                  border: "1px solid #ddd",
                }}
              >
                {/* Header */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "2fr 4fr 2fr 1fr",
                    background: "#8B1E3F",
                    color: "#fff",
                    padding: "10px 12px",
                    fontWeight: 600,
                    fontSize: "13px",
                  }}
                >
                  <div>Scheme Type</div>
                  <div>Scheme Name</div>
                  <div>Scheme Amount</div>
                  <div style={{ textAlign: "center" }}>Action</div>
                </div>

                {/* Rows */}
                {schemeGrid.map((row, index) => (
                  <div
                    key={row.id}
                    style={{
                      display: "grid",
                      gridTemplateColumns: "2fr 4fr 2fr 1fr",
                      padding: "10px 12px",
                      background: index % 2 === 0 ? "#fafafa" : "#fff",
                      borderTop: "1px solid #eee",
                      alignItems: "center",
                    }}
                  >
                    <div>{row.schemeType}</div>
                    <div>{row.schemeName}</div>
                    <div style={{ fontWeight: 600 }}>{row.schemeAmount}</div>

                    <div style={{ textAlign: "center" }}>
                      <button
                        style={{
                          background: "#dc3545",
                          color: "#fff",
                          border: "none",
                          padding: "5px 12px",
                          borderRadius: "6px",
                          cursor: "pointer",
                        }}
                        onClick={() => handleDeleteScheme(row.id)}
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
            <div className="ch-section-label"> </div>
            <div className="ch-grid ch-grid-3">
              <div className="ch-field">
                <label className="ch-label">Special Discount</label>
                <input
                  type="text"
                  className="ch-input"
                  value={Specialdiscount}
                  placeholder="Enter Special Discount"
                  maxLength="10"
                  onChange={(e) =>
                    setSpecialdiscount(e.target.value.replace(/[^0-9]/g, ""))
                  }
                />
              </div>
              <div className="ch-field">
                <label>Ex-ShowRoom</label>
                <input
                  type="text"
                  className="ch-input"
                  value={Exshowroom}
                  placeholder="Enter Ex-ShowRoom"
                  onChange={(e) => setExshowroom(e.target.value.toUpperCase())}
                />
              </div>
              <div className="ch-field">
                <label>Schemes Less</label>
                <input
                  type="text"
                  className="ch-input"
                  value={Schemesless}
                  placeholder="Enter Schemes Less"
                  onChange={(e) => setSchemesless(e.target.value.toUpperCase())}
                />
              </div>
              <div className="ch-field">
                <label>Sub Total</label>
                <input
                  type="text"
                  className="ch-input"
                  value={Subtotal}
                  placeholder="Enter Sub Total"
                  onChange={(e) => setSubtotal(e.target.value.toUpperCase())}
                />
              </div>
            </div>

            {/* ── Insurance Section ── */}
            <div
              className="ch-section-label"
              style={{
                cursor: "pointer",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
              onClick={() => setShowInsurance(!showInsurance)}
            >
              <span>🛡️ Insurance</span>
              <span>{showInsurance ? "▲" : "▼"}</span>
            </div>

            {showInsurance && (
              <div className="ch-accordion-body">
                {/* Insurance Type + Discount + Ex-Showroom */}
                <div className="ch-ins-topbar">
                  <div className="ch-ins-radio-group">
                    <label className="ch-radio-label">
                      <input
                        type="radio"
                        name="insType"
                        value="In House"
                        checked={InsuranceType === "In House"}
                        onChange={() => setInsuranceType("In House")}
                      />
                      <span>In House</span>
                    </label>
                    <label className="ch-radio-label">
                      <input
                        type="radio"
                        name="insType"
                        value="Out House"
                        checked={InsuranceType === "Out House"}
                        onChange={() => setInsuranceType("Out House")}
                      />
                      <span>Out House</span>
                    </label>
                  </div>
                  <div className="ch-ins-topbar-field">
                    <label className="ch-label">Insurance Discount%</label>
                    <input
                      type="text"
                      className="ch-input ch-amount-input"
                      value={InsuranceDiscount}
                      onChange={(e) =>
                        setInsuranceDiscount(
                          e.target.value.replace(/[^0-9.]/g, ""),
                        )
                      }
                    />
                  </div>
                  <div className="ch-ins-topbar-field">
                    <label className="ch-label">Insurance Ex-Showroom</label>
                    <input
                      type="text"
                      className="ch-input ch-amount-input"
                      value={InsuranceExShowroom}
                      onChange={(e) =>
                        setInsuranceExShowroom(
                          e.target.value.replace(/[^0-9.]/g, ""),
                        )
                      }
                    />
                  </div>
                </div>

                {/* Checkboxes */}
                <div className="ch-ins-checkbox-grid">
                  {[
                    ["Add EP", AddEP, setAddEP],
                    ["Add RTI", AddRTI, setAddRTI],
                    ["Add CM", AddCM, setAddCM],
                    ["Add PB", AddPB, setAddPB],
                    ["Add KP", AddKP, setAddKP],
                    ["Add ZD", AddZD, setAddZD],
                    [
                      "Add Nil Depreciation",
                      AddNilDepreciation,
                      setAddNilDepreciation,
                    ],
                    [
                      "Add Road Side Assistance",
                      AddRoadSideAssistance,
                      setAddRoadSideAssistance,
                    ],
                    ["Add Emi Cover", AddEmiCover, setAddEmiCover],
                    ["Add Lose Of Income", AddLoseOfIncome, setAddLoseOfIncome],
                    ["Add Consumables", AddConsumables, setAddConsumables],
                    ["Add Towing", AddTowing, setAddTowing],
                    [
                      "Add Emergency Transport And Hotel Expense",
                      AddEmergencyTransport,
                      setAddEmergencyTransport,
                    ],
                    [
                      "Add Daily Allowance",
                      AddDailyAllowance,
                      setAddDailyAllowance,
                    ],
                    [
                      "Add Tyre And Allow Cover",
                      AddTyreAndAllowCover,
                      setAddTyreAndAllowCover,
                    ],
                    [
                      "Add Charger Protection",
                      AddChargerProtection,
                      setAddChargerProtection,
                    ],
                    ["Add Battery Cover", AddBatteryCover, setAddBatteryCover],
                  ].map(([label, val, setter]) => (
                    <label key={label} className="ch-ins-checkbox-label">
                      <input
                        type="checkbox"
                        checked={val}
                        onChange={(e) => setter(e.target.checked)}
                      />
                      <span>{label}</span>
                    </label>
                  ))}
                </div>

                {/* Insurance Company + IDV */}
                <div
                  className="ch-grid ch-grid-4"
                  style={{ marginTop: "16px" }}
                >
                  <div className="ch-field">
                    <label className="ch-label">Insurance Company</label>
                    <Select
                      classNamePrefix="rs"
                      options={insuranceCompanyList}
                      value={
                        insuranceCompanyList.find(
                          (o) => o.value === InsuranceCompany,
                        ) || null
                      }
                      onChange={(s) => {
                        setInsuranceCompany(s?.value || "");
                      }}
                      styles={selectStyles}
                      placeholder="Select Insurance Company"
                      isSearchable
                      menuPortalTarget={document.body}
                      menuPosition="fixed"
                    />
                  </div>
                  <div className="ch-field">
                    <label className="ch-label">IDV</label>
                    <input
                      type="text"
                      className="ch-input ch-amount-input"
                      value={IDV}
                      onChange={(e) =>
                        setIDV(e.target.value.replace(/[^0-9.]/g, ""))
                      }
                    />
                  </div>
                  <div className="ch-field">
                    <label className="ch-label">IDV Amount</label>
                    <input
                      type="text"
                      className="ch-input ch-amount-input"
                      value={IDVAmount}
                      onChange={(e) =>
                        setIDVAmount(e.target.value.replace(/[^0-9.]/g, ""))
                      }
                    />
                  </div>
                  <div className="ch-field">
                    <label className="ch-label">After IDV</label>
                    <input
                      type="text"
                      className="ch-input ch-amount-input"
                      value={AfterIDV}
                      onChange={(e) =>
                        setAfterIDV(e.target.value.replace(/[^0-9.]/g, ""))
                      }
                    />
                  </div>
                </div>

                {/* Insurance % / Amount / Discount / After Discount */}
                <div className="ch-grid ch-grid-4">
                  <div className="ch-field">
                    <label className="ch-label">Insurance %</label>
                    <input
                      type="text"
                      className="ch-input ch-amount-input"
                      value={InsurancePct}
                      onChange={(e) =>
                        setInsurancePct(e.target.value.replace(/[^0-9.]/g, ""))
                      }
                    />
                  </div>
                  <div className="ch-field">
                    <label className="ch-label">Insurance Amount</label>
                    <input
                      type="text"
                      className="ch-input ch-amount-input"
                      value={InsuranceAmount}
                      onChange={(e) =>
                        setInsuranceAmount(
                          e.target.value.replace(/[^0-9.]/g, ""),
                        )
                      }
                    />
                  </div>
                  <div className="ch-field">
                    <label className="ch-label">Discount Amount</label>
                    <input
                      type="text"
                      className="ch-input ch-amount-input"
                      value={DiscountAmount}
                      onChange={(e) =>
                        setDiscountAmount(
                          e.target.value.replace(/[^0-9.]/g, ""),
                        )
                      }
                    />
                  </div>
                  <div className="ch-field">
                    <label className="ch-label">After Discount</label>
                    <input
                      type="text"
                      className="ch-input ch-amount-input"
                      value={AfterDiscount}
                      onChange={(e) =>
                        setAfterDiscount(e.target.value.replace(/[^0-9.]/g, ""))
                      }
                    />
                  </div>
                </div>

                {/* CNG / PA Cover / ZD / EP */}
                <div className="ch-grid ch-grid-4">
                  <div className="ch-field">
                    <label className="ch-label">CNG %</label>
                    <input
                      type="text"
                      className="ch-input ch-amount-input"
                      value={CNGPct}
                      onChange={(e) =>
                        setCNGPct(e.target.value.replace(/[^0-9.]/g, ""))
                      }
                    />
                  </div>
                  <div className="ch-field">
                    <label className="ch-label">CNG Amount</label>
                    <input
                      type="text"
                      className="ch-input ch-amount-input"
                      value={CNGAmount}
                      onChange={(e) =>
                        setCNGAmount(e.target.value.replace(/[^0-9.]/g, ""))
                      }
                    />
                  </div>
                  <div className="ch-field">
                    <label className="ch-label">PA Cover</label>
                    <input
                      type="text"
                      className="ch-input ch-amount-input"
                      value={PACover}
                      onChange={(e) =>
                        setPACover(e.target.value.replace(/[^0-9.]/g, ""))
                      }
                    />
                  </div>
                  <div className="ch-field">
                    <label className="ch-label">ZD%</label>
                    <input
                      type="text"
                      className="ch-input ch-amount-input"
                      value={ZDPct}
                      onChange={(e) =>
                        setZDPct(e.target.value.replace(/[^0-9.]/g, ""))
                      }
                    />
                  </div>
                </div>

                {/* ZD Amount / EP% / EP Amount / Third Party */}
                <div className="ch-grid ch-grid-4">
                  <div className="ch-field">
                    <label className="ch-label">ZD Amount</label>
                    <input
                      type="text"
                      className="ch-input ch-amount-input"
                      value={ZDAmount}
                      onChange={(e) =>
                        setZDAmount(e.target.value.replace(/[^0-9.]/g, ""))
                      }
                    />
                  </div>
                  <div className="ch-field">
                    <label className="ch-label">EP%</label>
                    <input
                      type="text"
                      className="ch-input ch-amount-input"
                      value={EPPct}
                      onChange={(e) =>
                        setEPPct(e.target.value.replace(/[^0-9.]/g, ""))
                      }
                    />
                  </div>
                  <div className="ch-field">
                    <label className="ch-label">EP Amount</label>
                    <input
                      type="text"
                      className="ch-input ch-amount-input"
                      value={EPAmount}
                      onChange={(e) =>
                        setEPAmount(e.target.value.replace(/[^0-9.]/g, ""))
                      }
                    />
                  </div>
                  <div className="ch-field">
                    <label className="ch-label">Third Party</label>
                    <input
                      type="text"
                      className="ch-input ch-amount-input"
                      value={ThirdParty}
                      onChange={(e) =>
                        setThirdParty(e.target.value.replace(/[^0-9.]/g, ""))
                      }
                    />
                  </div>
                </div>

                {/* PB% / KP Amount / Paid Driver / After PD */}
                <div className="ch-grid ch-grid-4">
                  <div className="ch-field">
                    <label className="ch-label">PB%</label>
                    <input
                      type="text"
                      className="ch-input ch-amount-input"
                      value={PBPct}
                      onChange={(e) =>
                        setPBPct(e.target.value.replace(/[^0-9.]/g, ""))
                      }
                    />
                  </div>
                  <div className="ch-field">
                    <label className="ch-label">KP Amount</label>
                    <input
                      type="text"
                      className="ch-input ch-amount-input"
                      value={KPAmount}
                      onChange={(e) =>
                        setKPAmount(e.target.value.replace(/[^0-9.]/g, ""))
                      }
                    />
                  </div>
                  <div className="ch-field">
                    <label className="ch-label">Paid Driver</label>
                    <input
                      type="text"
                      className="ch-input ch-amount-input"
                      value={PaidDriver}
                      onChange={(e) =>
                        setPaidDriver(e.target.value.replace(/[^0-9.]/g, ""))
                      }
                    />
                  </div>
                  <div className="ch-field">
                    <label className="ch-label">After PD</label>
                    <input
                      type="text"
                      className="ch-input ch-amount-input"
                      value={AfterPD}
                      onChange={(e) =>
                        setAfterPD(e.target.value.replace(/[^0-9.]/g, ""))
                      }
                    />
                  </div>
                </div>

                {/* RTI% / RTI Amount / CM% / CM Amount */}
                <div className="ch-grid ch-grid-4">
                  <div className="ch-field">
                    <label className="ch-label">RTI%</label>
                    <input
                      type="text"
                      className="ch-input ch-amount-input"
                      value={RTIPct}
                      onChange={(e) =>
                        setRTIPct(e.target.value.replace(/[^0-9.]/g, ""))
                      }
                    />
                  </div>
                  <div className="ch-field">
                    <label className="ch-label">RTI Amount</label>
                    <input
                      type="text"
                      className="ch-input ch-amount-input"
                      value={RTIAmount}
                      onChange={(e) =>
                        setRTIAmount(e.target.value.replace(/[^0-9.]/g, ""))
                      }
                    />
                  </div>
                  <div className="ch-field">
                    <label className="ch-label">CM%</label>
                    <input
                      type="text"
                      className="ch-input ch-amount-input"
                      value={CMPct}
                      onChange={(e) =>
                        setCMPct(e.target.value.replace(/[^0-9.]/g, ""))
                      }
                    />
                  </div>
                  <div className="ch-field">
                    <label className="ch-label">CM Amount</label>
                    <input
                      type="text"
                      className="ch-input ch-amount-input"
                      value={CMAmount}
                      onChange={(e) =>
                        setCMAmount(e.target.value.replace(/[^0-9.]/g, ""))
                      }
                    />
                  </div>
                </div>

                {/* GST / CGST / SGST / GST Amount */}
                <div className="ch-grid ch-grid-4">
                  <div className="ch-field">
                    <label className="ch-label">GST</label>
                    <input
                      type="text"
                      className="ch-input ch-amount-input"
                      value={InsGST}
                      onChange={(e) =>
                        setInsGST(e.target.value.replace(/[^0-9.]/g, ""))
                      }
                    />
                  </div>
                  <div className="ch-field">
                    <label className="ch-label">CGST</label>
                    <input
                      type="text"
                      className="ch-input ch-amount-input"
                      value={InsCGST}
                      onChange={(e) =>
                        setInsCGST(e.target.value.replace(/[^0-9.]/g, ""))
                      }
                    />
                  </div>
                  <div className="ch-field">
                    <label className="ch-label">SGST</label>
                    <input
                      type="text"
                      className="ch-input ch-amount-input"
                      value={InsSGST}
                      onChange={(e) =>
                        setInsSGST(e.target.value.replace(/[^0-9.]/g, ""))
                      }
                    />
                  </div>
                  <div className="ch-field">
                    <label className="ch-label">GST Amount</label>
                    <input
                      type="text"
                      className="ch-input ch-amount-input"
                      value={InsGSTAmount}
                      onChange={(e) =>
                        setInsGSTAmount(e.target.value.replace(/[^0-9.]/g, ""))
                      }
                    />
                  </div>
                </div>

                {/* NCB / Nil Depreciation / Road Side Assistance / FMI Cover */}
                <div className="ch-grid ch-grid-4">
                  <div className="ch-field">
                    <label className="ch-label">NCB</label>
                    <input
                      type="text"
                      className="ch-input ch-amount-input"
                      value={InsNCB}
                      onChange={(e) =>
                        setInsNCB(e.target.value.replace(/[^0-9.]/g, ""))
                      }
                    />
                  </div>
                  <div className="ch-field">
                    <label className="ch-label">Nil Depreciation</label>
                    <input
                      type="text"
                      className="ch-input ch-amount-input"
                      value={InsNilDepreciation}
                      onChange={(e) =>
                        setInsNilDepreciation(
                          e.target.value.replace(/[^0-9.]/g, ""),
                        )
                      }
                    />
                  </div>
                  <div className="ch-field">
                    <label className="ch-label">Road Side Assistance</label>
                    <input
                      type="text"
                      className="ch-input ch-amount-input"
                      value={InsRoadSideAssistance}
                      onChange={(e) =>
                        setInsRoadSideAssistance(
                          e.target.value.replace(/[^0-9.]/g, ""),
                        )
                      }
                    />
                  </div>
                  <div className="ch-field">
                    <label className="ch-label">FMI Cover</label>
                    <input
                      type="text"
                      className="ch-input ch-amount-input"
                      value={InsFMICover}
                      onChange={(e) =>
                        setInsFMICover(e.target.value.replace(/[^0-9.]/g, ""))
                      }
                    />
                  </div>
                </div>

                {/* Loss Of Income / Consumables / Towing / Daily Allowance */}
                <div className="ch-grid ch-grid-4">
                  <div className="ch-field">
                    <label className="ch-label">Loss Of Income</label>
                    <input
                      type="text"
                      className="ch-input ch-amount-input"
                      value={InsLossOfIncome}
                      onChange={(e) =>
                        setInsLossOfIncome(
                          e.target.value.replace(/[^0-9.]/g, ""),
                        )
                      }
                    />
                  </div>
                  <div className="ch-field">
                    <label className="ch-label">Consumables</label>
                    <input
                      type="text"
                      className="ch-input ch-amount-input"
                      value={InsConsumables}
                      onChange={(e) =>
                        setInsConsumables(
                          e.target.value.replace(/[^0-9.]/g, ""),
                        )
                      }
                    />
                  </div>
                  <div className="ch-field">
                    <label className="ch-label">Towing</label>
                    <input
                      type="text"
                      className="ch-input ch-amount-input"
                      value={InsTowing}
                      onChange={(e) =>
                        setInsTowing(e.target.value.replace(/[^0-9.]/g, ""))
                      }
                    />
                  </div>
                  <div className="ch-field">
                    <label className="ch-label">Daily Allowance</label>
                    <input
                      type="text"
                      className="ch-input ch-amount-input"
                      value={InsDailyAllowance}
                      onChange={(e) =>
                        setInsDailyAllowance(
                          e.target.value.replace(/[^0-9.]/g, ""),
                        )
                      }
                    />
                  </div>
                </div>

                {/* Tyre And Allow Cover / Emergency Transport / Charger Protection / Battery Cover */}
                <div className="ch-grid ch-grid-4">
                  <div className="ch-field">
                    <label className="ch-label">Tyre And Allow Cover</label>
                    <input
                      type="text"
                      className="ch-input ch-amount-input"
                      value={InsTyreAndAllowCover}
                      onChange={(e) =>
                        setInsTyreAndAllowCover(
                          e.target.value.replace(/[^0-9.]/g, ""),
                        )
                      }
                    />
                  </div>
                  <div className="ch-field">
                    <label className="ch-label">
                      Emergency Transport And Hotel Expense
                    </label>
                    <input
                      type="text"
                      className="ch-input ch-amount-input"
                      value={InsEmergencyTransport}
                      onChange={(e) =>
                        setInsEmergencyTransport(
                          e.target.value.replace(/[^0-9.]/g, ""),
                        )
                      }
                    />
                  </div>
                  <div className="ch-field">
                    <label className="ch-label">Charger Protection</label>
                    <input
                      type="text"
                      className="ch-input ch-amount-input"
                      value={InsChargerProtection}
                      onChange={(e) =>
                        setInsChargerProtection(
                          e.target.value.replace(/[^0-9.]/g, ""),
                        )
                      }
                    />
                  </div>
                  <div className="ch-field">
                    <label className="ch-label">Battery Cover</label>
                    <input
                      type="text"
                      className="ch-input ch-amount-input"
                      value={InsBatteryCover}
                      onChange={(e) =>
                        setInsBatteryCover(
                          e.target.value.replace(/[^0-9.]/g, ""),
                        )
                      }
                    />
                  </div>
                </div>

                {/* Insurance Total Amount */}
                <div className="ch-grid ch-grid-4">
                  <div className="ch-field">
                    <label className="ch-label">Insurance Amount</label>
                    <input
                      type="text"
                      className="ch-input ch-amount-input"
                      value={InsTotalAmount}
                      onChange={(e) =>
                        setInsTotalAmount(
                          e.target.value.replace(/[^0-9.]/g, ""),
                        )
                      }
                    />
                  </div>
                </div>
              </div>
            )}

            {/* ── RTO Section ── */}
            <div
              className="ch-section-label"
              style={{
                cursor: "pointer",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
              onClick={() => setShowRTO(!showRTO)}
            >
              <span>🚗 RTO</span>
              <span>{showRTO ? "▲" : "▼"}</span>
            </div>

            {showRTO && (
              <div className="ch-accordion-body">
                {/* RTO Top Bar */}
                <div className="ch-ins-topbar">
                  <div className="ch-ins-radio-group">
                    <label className="ch-radio-label">
                      <input
                        type="radio"
                        name="rtoType"
                        value="In House"
                        checked={RTOType === "In House"}
                        onChange={() => setRTOType("In House")}
                      />
                      <span>In House</span>
                    </label>
                    <label className="ch-radio-label">
                      <input
                        type="radio"
                        name="rtoType"
                        value="Out House"
                        checked={RTOType === "Out House"}
                        onChange={() => setRTOType("Out House")}
                      />
                      <span>Out House</span>
                    </label>
                    <label className="ch-radio-label">
                      <input
                        type="radio"
                        name="rtoType"
                        value="BH"
                        checked={RTOType === "BH"}
                        onChange={() => setRTOType("BH")}
                      />
                      <span>BH</span>
                    </label>
                  </div>
                  <div className="ch-ins-topbar-field">
                    <label className="ch-radio-label" style={{ color: "#fff" }}>
                      <input
                        type="checkbox"
                        checked={LocalTaxApplicable}
                        onChange={(e) =>
                          setLocalTaxApplicable(e.target.checked)
                        }
                        style={{ marginRight: "6px", accentColor: "#fff" }}
                      />
                      Local Tax Applicable
                    </label>
                  </div>
                  <div className="ch-ins-topbar-field">
                    <label className="ch-label">RTO Ex-Showroom</label>
                    <input
                      type="text"
                      className="ch-input ch-amount-input"
                      value={RTOExShowroom}
                      onChange={(e) =>
                        setRTOExShowroom(e.target.value.replace(/[^0-9.]/g, ""))
                      }
                    />
                  </div>
                </div>

                {/* Row 1 – Vehicle Purchase / RTO Rate / RTO Tax Surcharge / Green Tax */}
                <div
                  className="ch-grid ch-grid-4"
                  style={{ marginTop: "16px" }}
                >
                  <div className="ch-field">
                    <label className="ch-label">Vehicle Purchase</label>
                    <select
                      className="ch-input"
                      value={VehiclePurchase}
                      onChange={(e) => setVehiclePurchase(e.target.value)}
                      style={{
                        height: "42px",
                        borderRadius: "8px",
                        border: "1.5px solid #ddd",
                        background: "#fafafa",
                        fontSize: "14px",
                        padding: "0 12px",
                      }}
                    >
                      <option value="ONL">ONL</option>
                      <option value="NEW">NEW</option>
                      <option value="USED">USED</option>
                    </select>
                  </div>
                  <div className="ch-field">
                    <label className="ch-label">RTO Rate</label>
                    <input
                      type="text"
                      className="ch-input ch-amount-input"
                      value={RTORate}
                      onChange={(e) =>
                        setRTORate(e.target.value.replace(/[^0-9.]/g, ""))
                      }
                    />
                  </div>
                  <div className="ch-field">
                    <label className="ch-label">RTO Tax Surcharge</label>
                    <input
                      type="text"
                      className="ch-input ch-amount-input"
                      value={RTOTaxSurcharge}
                      onChange={(e) =>
                        setRTOTaxSurcharge(
                          e.target.value.replace(/[^0-9.]/g, ""),
                        )
                      }
                    />
                  </div>
                  <div className="ch-field">
                    <label className="ch-label">Green Tax</label>
                    <input
                      type="text"
                      className="ch-input ch-amount-input"
                      value={GreenTax}
                      onChange={(e) =>
                        setGreenTax(e.target.value.replace(/[^0-9.]/g, ""))
                      }
                    />
                  </div>
                </div>

                {/* Row 2 – Reg Fee / HPN / Duplicate / Smart Card */}
                <div className="ch-grid ch-grid-4">
                  <div className="ch-field">
                    <label className="ch-label">Reg Fee</label>
                    <input
                      type="text"
                      className="ch-input ch-amount-input"
                      value={RegFee}
                      onChange={(e) =>
                        setRegFee(e.target.value.replace(/[^0-9.]/g, ""))
                      }
                    />
                  </div>
                  <div className="ch-field">
                    <label className="ch-label">HPN</label>
                    <input
                      type="text"
                      className="ch-input ch-amount-input"
                      value={HPN}
                      onChange={(e) =>
                        setHPN(e.target.value.replace(/[^0-9.]/g, ""))
                      }
                    />
                  </div>
                  <div className="ch-field">
                    <label className="ch-label">Duplicate</label>
                    <input
                      type="text"
                      className="ch-input ch-amount-input"
                      value={Duplicate}
                      onChange={(e) =>
                        setDuplicate(e.target.value.replace(/[^0-9.]/g, ""))
                      }
                    />
                  </div>
                  <div className="ch-field">
                    <label className="ch-label">Smart Card</label>
                    <input
                      type="text"
                      className="ch-input ch-amount-input"
                      value={SmartCard}
                      onChange={(e) =>
                        setSmartCard(e.target.value.replace(/[^0-9.]/g, ""))
                      }
                    />
                  </div>
                </div>

                {/* Row 3 – Other / BH Year / Vehiclecc / RTO Temporary */}
                <div className="ch-grid ch-grid-4">
                  <div className="ch-field">
                    <label className="ch-label">Other</label>
                    <input
                      type="text"
                      className="ch-input ch-amount-input"
                      value={Other}
                      onChange={(e) =>
                        setOther(e.target.value.replace(/[^0-9.]/g, ""))
                      }
                    />
                  </div>
                  <div className="ch-field">
                    <label className="ch-label">BH Year</label>
                    <input
                      type="text"
                      className="ch-input"
                      value={BHYear}
                      onChange={(e) => setBHYear(e.target.value)}
                    />
                  </div>
                  <div className="ch-field">
                    <label className="ch-label">Vehiclecc</label>
                    <input
                      type="text"
                      className="ch-input"
                      value={Vehiclecc}
                      onChange={(e) => setVehiclecc(e.target.value)}
                    />
                  </div>
                  <div className="ch-field">
                    <label className="ch-label">RTO Temporary</label>
                    <input
                      type="text"
                      className="ch-input ch-amount-input"
                      value={RTOTemporary}
                      onChange={(e) =>
                        setRTOTemporary(e.target.value.replace(/[^0-9.]/g, ""))
                      }
                    />
                  </div>
                </div>

                {/* Row 4 – Scrappage / RTO Amount / MCD Charge / Excluding Tax */}
                <div className="ch-grid ch-grid-4">
                  <div className="ch-field">
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        paddingTop: "22px",
                        marginBottom: "6px",
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={Scrappage}
                        onChange={(e) => setScrappage(e.target.checked)}
                        style={{
                          width: "15px",
                          height: "15px",
                          accentColor: "#8B1E3F",
                        }}
                      />
                      <label className="ch-label" style={{ marginBottom: 0 }}>
                        Scrappage
                      </label>
                    </div>
                    <input
                      type="text"
                      className="ch-input ch-amount-input"
                      value={ScrappagePct}
                      placeholder="Scrappage %"
                      disabled={!Scrappage}
                      onChange={(e) =>
                        setScrappagePct(e.target.value.replace(/[^0-9.]/g, ""))
                      }
                      style={{ background: !Scrappage ? "#f0f0f0" : undefined }}
                    />
                  </div>
                  <div className="ch-field">
                    <label className="ch-label">RTO Amount</label>
                    <input
                      type="text"
                      className="ch-input ch-amount-input"
                      value={RTOAmount}
                      onChange={(e) =>
                        setRTOAmount(e.target.value.replace(/[^0-9.]/g, ""))
                      }
                    />
                  </div>
                  <div className="ch-field">
                    <label className="ch-label">MCD CHARGE</label>
                    <input
                      type="text"
                      className="ch-input ch-amount-input"
                      value={MCDCharge}
                      onChange={(e) =>
                        setMCDCharge(e.target.value.replace(/[^0-9.]/g, ""))
                      }
                    />
                  </div>
                  <div className="ch-field">
                    <label className="ch-label">Excluding Tax</label>
                    <input
                      type="text"
                      className="ch-input"
                      value={ExcludingTax}
                      onChange={(e) => setExcludingTax(e.target.value)}
                    />
                  </div>
                </div>

                {/* Row 5 – Other Charge / Type / Number Plate / Road Safety Tax */}
                <div className="ch-grid ch-grid-4">
                  <div className="ch-field">
                    <label className="ch-label">OTHER CHARGE</label>
                    <input
                      type="text"
                      className="ch-input"
                      value={OtherCharge}
                      onChange={(e) => setOtherCharge(e.target.value)}
                    />
                  </div>
                  <div className="ch-field">
                    <label className="ch-label">TYPE</label>
                    <input
                      type="text"
                      className="ch-input"
                      value={RTOType2}
                      onChange={(e) => setRTOType2(e.target.value)}
                    />
                  </div>
                  <div className="ch-field">
                    <label className="ch-label">NUMBER PLATE</label>
                    <input
                      type="text"
                      className="ch-input"
                      value={NumberPlate}
                      onChange={(e) =>
                        setNumberPlate(e.target.value.toUpperCase())
                      }
                    />
                  </div>
                  <div className="ch-field">
                    <label className="ch-label">ROAD SAFETY TAX</label>
                    <input
                      type="text"
                      className="ch-input"
                      value={RoadSafetyTax}
                      onChange={(e) => setRoadSafetyTax(e.target.value)}
                    />
                  </div>
                </div>

                {/* Row 6 – RTO Surcharge / CNG Kit Charge / Vehicle Count / Local Tax */}
                <div className="ch-grid ch-grid-4">
                  <div className="ch-field">
                    <label className="ch-label">RTO SURCHARGE</label>
                    <input
                      type="text"
                      className="ch-input"
                      value={RTOSurcharge}
                      onChange={(e) => setRTOSurcharge(e.target.value)}
                    />
                  </div>
                  <div className="ch-field">
                    <label className="ch-label">CNG KIT CHARGE</label>
                    <input
                      type="text"
                      className="ch-input"
                      value={CNGKitCharge}
                      onChange={(e) => setCNGKitCharge(e.target.value)}
                    />
                  </div>
                  <div className="ch-field">
                    <label className="ch-label">VEHICLE COUNT</label>
                    <input
                      type="text"
                      className="ch-input"
                      value={VehicleCount}
                      onChange={(e) =>
                        setVehicleCount(e.target.value.replace(/[^0-9]/g, ""))
                      }
                    />
                  </div>
                  <div className="ch-field">
                    <label className="ch-label">LOCAL TAX</label>
                    <input
                      type="text"
                      className="ch-input"
                      value={LocalTax}
                      onChange={(e) => setLocalTax(e.target.value)}
                    />
                  </div>
                </div>
              </div>
            )}

            {/* ── Others Section ── */}
            <div
              className="ch-section-label"
              style={{
                cursor: "pointer",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
              onClick={() => setShowOthers(!showOthers)}
            >
              <span>Others</span>
              <span>{showOthers ? "▲" : "▼"}</span>
            </div>

            {showOthers && (
              <div className="ch-accordion-body">
                <div
                  className="ch-grid ch-grid-4"
                  style={{ alignItems: "flex-end" }}
                >
                  <div className="ch-field">
                    <label className="ch-label">Other 1</label>
                    <select
                      className="ch-input"
                      value={OtherItem}
                      onChange={(e) => setOtherItem(e.target.value)}
                      style={{
                        height: "42px",
                        borderRadius: "8px",
                        border: "1.5px solid #ddd",
                        background: "#fafafa",
                        fontSize: "14px",
                        padding: "0 12px",
                      }}
                    >
                      <option value="">-- Select --</option>
                    </select>
                  </div>
                  <div className="ch-field">
                    <label className="ch-label">Amount 1</label>
                    <input
                      type="text"
                      className="ch-input ch-amount-input"
                      value={OtherAmount}
                      onChange={(e) =>
                        setOtherAmount(e.target.value.replace(/[^0-9.]/g, ""))
                      }
                    />
                  </div>
                  <div className="ch-field">
                    <button
                      type="button"
                      style={{
                        background: "#28a745",
                        color: "#fff",
                        border: "none",
                        padding: "10px 20px",
                        borderRadius: "6px",
                        fontWeight: 600,
                        cursor: "pointer",
                        marginTop: "22px",
                      }}
                      onClick={handleAddOther}
                    >
                      Add Other
                    </button>
                  </div>
                </div>

                {/* Others Grid — always visible */}
                <div
                  style={{
                    marginTop: "16px",
                    borderRadius: "8px",
                    overflow: "hidden",
                    border: "1px solid #ddd",
                  }}
                >
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "3fr 3fr 1fr",
                      background: "#8B1E3F",
                      color: "#fff",
                      padding: "10px 12px",
                      fontWeight: 600,
                      fontSize: "13px",
                    }}
                  >
                    <div>Other Name</div>
                    <div>Other Amount</div>
                    <div style={{ textAlign: "center" }}>Action</div>
                  </div>
                  {othersGrid.map((row, index) => (
                    <div
                      key={row.id}
                      style={{
                        display: "grid",
                        gridTemplateColumns: "3fr 3fr 1fr",
                        padding: "10px 12px",
                        background: index % 2 === 0 ? "#fafafa" : "#fff",
                        borderTop: "1px solid #eee",
                        alignItems: "center",
                      }}
                    >
                      <div>{row.otherItem}</div>
                      <div style={{ fontWeight: 600 }}>{row.otherAmount}</div>
                      <div style={{ textAlign: "center" }}>
                        <button
                          style={{
                            background: "#dc3545",
                            color: "#fff",
                            border: "none",
                            padding: "5px 12px",
                            borderRadius: "6px",
                            cursor: "pointer",
                          }}
                          onClick={() => handleDeleteOther(row.id)}
                        >
                          Delete
                        </button>
                      </div>
                    </div>
                  ))}
                  {othersGrid.length === 0 && (
                    <div
                      style={{
                        padding: "10px 12px",
                        textAlign: "center",
                        color: "#aaa",
                        fontSize: "13px",
                        background: "#fafafa",
                      }}
                    >
                      No items added
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* ── Other Details Section ── */}
            <div className="ch-section-label" style={{ marginTop: "18px" }}>
              {" "}
            </div>
            <div
              className="ch-accordion-body"
              style={{ border: "1px solid #ddd" }}
            >
              {/* 2-column layout: left = Workshop/RTO, right = all amount fields */}
              <div
                className="ch-other-details-grid"
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: "16px 32px",
                }}
              >
                {/* LEFT COLUMN */}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "14px",
                  }}
                >
                  <div className="ch-field">
                    <label className="ch-label">Workshop INV No.</label>
                    <input
                      type="text"
                      className="ch-input"
                      value={WorkshopINVNo}
                      onChange={(e) => setWorkshopINVNo(e.target.value)}
                    />
                  </div>
                  <div className="ch-field">
                    <label className="ch-label">RTO City</label>
                    <div className="ch-with-btn">
                      <Select
                        classNamePrefix="rs"
                        options={RTOCityList}
                        value={
                          RTOCityList.find((o) => o.value === RTOCity) || null
                        }
                        onChange={(s) => setRTOCity(s?.value || "")}
                        styles={selectStyles}
                        placeholder="Select City"
                        isSearchable
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                      />
                      <button
                        type="button"
                        className="ch-add-btn"
                        onClick={() => setShowRTOCityModal(true)}
                      >
                        +
                      </button>
                    </div>
                  </div>
                </div>

                {/* RIGHT COLUMN */}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "14px",
                  }}
                >
                  <div className="ch-field">
                    <label className="ch-label">Workshop INV Amt</label>
                    <input
                      type="text"
                      className="ch-input ch-amount-input"
                      value={WorkshopINVAmt}
                      onChange={(e) =>
                        setWorkshopINVAmt(
                          e.target.value.replace(/[^0-9.]/g, ""),
                        )
                      }
                    />
                  </div>
                  <div className="ch-field">
                    <label className="ch-label">TRC</label>
                    <input
                      type="text"
                      className="ch-input ch-amount-input"
                      value={TRC}
                      onChange={(e) =>
                        setTRC(e.target.value.replace(/[^0-9.]/g, ""))
                      }
                    />
                  </div>
                  <div className="ch-field">
                    <label className="ch-label">Company Accessories</label>
                    <div
                      style={{
                        display: "flex",
                        gap: "6px",
                        alignItems: "center",
                      }}
                    >
                      <input
                        type="text"
                        className="ch-input ch-amount-input"
                        value={CompanyAccessories}
                        onChange={(e) =>
                          setCompanyAccessories(
                            e.target.value.replace(/[^0-9.]/g, ""),
                          )
                        }
                      />
                      <button
                        type="button"
                        className="ch-add-btn"
                        onClick={() => setShowAccessoriesModal(true)}
                      >
                        +
                      </button>
                    </div>
                  </div>
                  <div className="ch-field">
                    <label className="ch-label">Own Accessories</label>
                    <input
                      type="text"
                      className="ch-input ch-amount-input"
                      value={OwnAccessories}
                      onChange={(e) =>
                        setOwnAccessories(
                          e.target.value.replace(/[^0-9.]/g, ""),
                        )
                      }
                    />
                  </div>
                  <div className="ch-field">
                    <label className="ch-label">Accessories Amount</label>
                    <input
                      type="text"
                      className="ch-input"
                      value={AccessoriesAmount}
                      onChange={(e) => setAccessoriesAmount(e.target.value)}
                    />
                  </div>
                  <div className="ch-field">
                    <label className="ch-label">Warranty</label>
                    <input
                      type="text"
                      className="ch-input ch-amount-input"
                      value={Warranty}
                      onChange={(e) =>
                        setWarranty(e.target.value.replace(/[^0-9.]/g, ""))
                      }
                    />
                  </div>
                  <div className="ch-field">
                    <label className="ch-label">RSA</label>
                    <input
                      type="text"
                      className="ch-input ch-amount-input"
                      value={RSA}
                      onChange={(e) =>
                        setRSA(e.target.value.replace(/[^0-9.]/g, ""))
                      }
                    />
                  </div>
                  <div className="ch-field">
                    <label className="ch-label">Sot</label>
                    <div
                      className="ch-sot-flex"
                      style={{ display: "flex", gap: "8px" }}
                    >
                      <select
                        className="ch-input"
                        value={SotType}
                        onChange={(e) => setSotType(e.target.value)}
                        style={{
                          height: "42px",
                          borderRadius: "8px",
                          border: "1.5px solid #ddd",
                          background: "#fafafa",
                          fontSize: "14px",
                          padding: "0 8px",
                          flex: 1,
                        }}
                      >
                        <option value="">Sot</option>
                        <option value="Fitment">Fitment</option>
                        <option value="Painting">Painting</option>
                        <option value="Labour Charge">Labour Charge</option>
                        <option value="Other Charge">Other Charge</option>
                      </select>
                      <input
                        type="text"
                        className="ch-input ch-amount-input"
                        value={SotAmount}
                        onChange={(e) =>
                          setSotAmount(e.target.value.replace(/[^0-9.]/g, ""))
                        }
                        style={{ flex: 1 }}
                      />
                    </div>
                  </div>
                  <div className="ch-field">
                    <label className="ch-label">Fast Tag</label>
                    <input
                      type="text"
                      className="ch-input ch-amount-input"
                      value={FastTag}
                      onChange={(e) =>
                        setFastTag(e.target.value.replace(/[^0-9.]/g, ""))
                      }
                    />
                  </div>
                  <div className="ch-field">
                    <label className="ch-label">TCS</label>
                    <input
                      type="text"
                      className="ch-input ch-amount-input"
                      value={TCS}
                      onChange={(e) =>
                        setTCS(e.target.value.replace(/[^0-9.]/g, ""))
                      }
                    />
                  </div>
                  <div className="ch-field">
                    <label className="ch-label" style={{ fontWeight: 700 }}>
                      Total
                    </label>
                    <input
                      type="text"
                      className="ch-input ch-amount-input ch-readonly"
                      value={OtherTotal}
                      readOnly
                    />
                  </div>
                </div>
              </div>

              {/* Payment Grid */}
              <div
                className="ch-payment-grid-wrapper"
                style={{
                  marginTop: "20px",
                  borderRadius: "8px",
                  overflow: "auto",
                  border: "1px solid #ddd",
                }}
              >
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns:
                      "0.6fr 1fr 1.2fr 1fr 1.2fr 1fr 1.5fr 1fr 1fr 1.2fr 1fr",
                    background: "#8B1E3F",
                    color: "#fff",
                    padding: "10px 8px",
                    fontWeight: 600,
                    fontSize: "12px",
                    minWidth: "900px",
                  }}
                >
                  <div>RNo</div>
                  <div>Date</div>
                  <div>Cheque No.</div>
                  <div>Cash</div>
                  <div>Cheque Amt</div>
                  <div>UPI</div>
                  <div>RTGS/NEFT/MPS</div>
                  <div>Wallet</div>
                  <div>Card</div>
                  <div>Received</div>
                  <div>Total</div>
                </div>
                {paymentGrid.length === 0 && (
                  <div
                    style={{
                      padding: "12px",
                      textAlign: "center",
                      color: "#aaa",
                      fontSize: "13px",
                      background: "#fafafa",
                      minWidth: "900px",
                    }}
                  >
                    No payment records
                  </div>
                )}
              </div>

              {/* Final Summary Section */}
              <div className="ch-section-label" style={{ marginTop: "18px" }}>
                {" "}
              </div>
              <div style={{ padding: "16px 0" }}>
                {/* Amounts grid – 2 columns */}
                <div
                  className="ch-summary-amounts-grid"
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: "14px 48px",
                    maxWidth: "700px",
                    margin: "0 auto",
                  }}
                >
                  <div className="ch-field">
                    <label className="ch-label">HPN Received Amt</label>
                    <input
                      type="text"
                      className="ch-input ch-amount-input"
                      value={HPNReceivedAmt}
                      onChange={(e) =>
                        setHPNReceivedAmt(
                          e.target.value.replace(/[^0-9.]/g, ""),
                        )
                      }
                    />
                  </div>
                  <div className="ch-field">
                    <label className="ch-label">HPN Balance</label>
                    <input
                      type="text"
                      className="ch-input ch-amount-input ch-readonly"
                      value={HPNBalance}
                      readOnly
                    />
                  </div>
                  <div className="ch-field">
                    <label className="ch-label">Customer Received Amt</label>
                    <input
                      type="text"
                      className="ch-input ch-amount-input"
                      value={CustomerReceivedAmt}
                      onChange={(e) =>
                        setCustomerReceivedAmt(
                          e.target.value.replace(/[^0-9.]/g, ""),
                        )
                      }
                    />
                  </div>
                  <div className="ch-field">
                    <label className="ch-label">Customer Balance</label>
                    <input
                      type="text"
                      className="ch-input ch-amount-input ch-readonly"
                      value={CustomerBalance}
                      readOnly
                    />
                  </div>
                  <div className="ch-field">
                    <label className="ch-label">Received Amt</label>
                    <input
                      type="text"
                      className="ch-input ch-amount-input ch-readonly"
                      value={ReceivedAmt}
                      readOnly
                    />
                  </div>
                  <div className="ch-field">
                    <label className="ch-label">Balance</label>
                    <input
                      type="text"
                      className="ch-input ch-amount-input ch-readonly"
                      value={Balance}
                      readOnly
                    />
                  </div>
                </div>

                {/* Remarks */}
                <div
                  className="ch-summary-remarks-grid"
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: "14px 48px",
                    marginTop: "16px",
                  }}
                >
                  <div className="ch-field">
                    <label className="ch-label">Remark</label>
                    <textarea
                      className="ch-input"
                      value={Remark}
                      onChange={(e) => setRemark(e.target.value)}
                      rows="3"
                      style={{ resize: "vertical", minHeight: "70px" }}
                    />
                  </div>
                  <div className="ch-field">
                    <label className="ch-label">Approval Remark</label>
                    <textarea
                      className="ch-input"
                      value={ApprovalRemark}
                      onChange={(e) => setApprovalRemark(e.target.value)}
                      rows="3"
                      style={{ resize: "vertical", minHeight: "70px" }}
                    />
                  </div>
                </div>

                {/* Save / Exit Buttons */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "16px",
                    marginTop: "28px",
                  }}
                >
                  <button
                    type="button"
                    style={{
                      background: "#28a745",
                      color: "#fff",
                      border: "none",
                      padding: "10px 40px",
                      borderRadius: "6px",
                      fontWeight: 600,
                      fontSize: "14px",
                      cursor: "pointer",
                      minWidth: "120px",
                    }}
                  >
                    Save
                  </button>
                  <button
                    type="button"
                    style={{
                      background: "#dc3545",
                      color: "#fff",
                      border: "none",
                      padding: "10px 40px",
                      borderRadius: "6px",
                      fontWeight: 600,
                      fontSize: "14px",
                      cursor: "pointer",
                      minWidth: "120px",
                    }}
                  >
                    Exit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* City Modal */}
      {showCityModal && (
        <div className="ch-overlay">
          <div className="ch-modal">
            <div className="ch-modal-hdr">
              <span>Add City</span>
              <button
                className="ch-modal-x"
                onClick={() => setShowCityModal(false)}
              >
                ✕
              </button>
            </div>
            <div className="ch-modal-body">
              <div className="ch-modal-grid">
                <div className="ch-field">
                  <label className="ch-label">State *</label>
                  <input
                    type="text"
                    value={
                      StateList.find((s) => s.value === State)?.label || ""
                    }
                    readOnly
                    className="ch-input"
                  />
                </div>
                <div className="ch-field">
                  <label className="ch-label">City *</label>
                  <input
                    type="text"
                    className="ch-input"
                    value={newCityName}
                    onChange={(e) =>
                      setNewCityName(e.target.value.replace(/[^a-zA-Z ]/g, ""))
                    }
                  />
                </div>
              </div>
            </div>
            <div className="ch-modal-ftr">
              <button onClick={handleCitySave}>Save</button>
              <button
                className="ch-btn-cancel"
                onClick={() => setShowCityModal(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Area Modal */}
      {showAreaModal && (
        <div className="ch-overlay">
          <div className="ch-modal">
            <div className="ch-modal-hdr">
              <span>Add Area</span>
              <button
                className="ch-modal-x"
                onClick={() => setShowAreaModal(false)}
              >
                ✕
              </button>
            </div>
            <div className="ch-modal-body">
              <div className="ch-field">
                <label className="ch-label">Area *</label>
                <input
                  type="text"
                  className="ch-input"
                  value={newAreaName}
                  onChange={(e) =>
                    setNewAreaName(e.target.value.replace(/[^a-zA-Z ]/g, ""))
                  }
                />
              </div>
            </div>
            <div className="ch-modal-ftr">
              <button onClick={handleAreaSave}>Save</button>
              <button
                className="ch-btn-cancel"
                onClick={() => setShowAreaModal(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* RTO City Modal */}
      {showRTOCityModal && (
        <div className="ch-overlay">
          <div className="ch-modal" style={{ width: "520px" }}>
            <div className="ch-modal-hdr">
              <span>Add Account</span>
              <button
                className="ch-modal-x"
                onClick={() => setShowRTOCityModal(false)}
              >
                ✕
              </button>
            </div>
            <div className="ch-modal-body">
              <div className="ch-modal-grid">
                <div className="ch-field">
                  <label className="ch-label">Rto City :</label>
                  <input
                    type="text"
                    className="ch-input"
                    value={rtoModalCity}
                    onChange={(e) => setRtoModalCity(e.target.value)}
                  />
                </div>
                <div className="ch-field">
                  <label className="ch-label">Main City :</label>
                  <input
                    type="text"
                    className="ch-input"
                    value={rtoModalMainCity}
                    onChange={(e) => setRtoModalMainCity(e.target.value)}
                  />
                </div>
              </div>
              <div style={{ marginTop: "14px" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "8px",
                  }}
                >
                  <span style={{ fontWeight: 600, fontSize: "13px" }}>
                    RTO Charges Applicable
                  </span>
                  <label
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      fontSize: "13px",
                      fontWeight: 600,
                    }}
                  >
                    Check All
                    <input
                      type="checkbox"
                      checked={rtoCheckAll}
                      onChange={(e) => handleRtoCheckAll(e.target.checked)}
                      style={{
                        width: "15px",
                        height: "15px",
                        accentColor: "#8B1E3F",
                      }}
                    />
                  </label>
                </div>
                {[
                  ["Rto Rate", "rtoRate"],
                  ["Rto Tax Surcharge", "rtoTaxSurcharge"],
                  ["Green Tax", "greenTax"],
                  ["Reg Fee", "regFee"],
                  ["HPN", "hpn"],
                  ["Duplicate", "duplicate"],
                  ["Smart Card", "smartCard"],
                  ["Other", "other"],
                  ["TRC", "trc"],
                ].map(([label, key]) => (
                  <div
                    key={key}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      padding: "5px 0",
                      borderBottom: "1px solid #f0f0f0",
                    }}
                  >
                    <span style={{ flex: 1, fontSize: "13px" }}>{label}</span>
                    <input
                      type="checkbox"
                      checked={rtoChecks[key]}
                      onChange={(e) =>
                        setRtoChecks({ ...rtoChecks, [key]: e.target.checked })
                      }
                      style={{
                        width: "15px",
                        height: "15px",
                        accentColor: "#8B1E3F",
                      }}
                    />
                  </div>
                ))}
              </div>
            </div>
            <div className="ch-modal-ftr">
              <button className="ch-btn-save">Save</button>
              <button
                className="ch-btn-cancel"
                onClick={() => setShowRTOCityModal(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Accessories Details Modal */}
      {showAccessoriesModal && (
        <div className="ch-overlay">
          <div
            className="ch-modal"
            style={{ width: "860px", maxWidth: "96vw" }}
          >
            <div className="ch-modal-hdr">
              <span>Accessories Details</span>
              <button
                className="ch-modal-x"
                onClick={() => setShowAccessoriesModal(false)}
              >
                ✕
              </button>
            </div>
            <div className="ch-modal-body">
              {/* Grid wrapper with horizontal scroll */}
              <div
                style={{ overflowX: "auto", WebkitOverflowScrolling: "touch" }}
              >
                {/* Grid header */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns:
                      "1.2fr 2fr 1fr 1fr 1fr 1fr 1.2fr 1.2fr",
                    background: "#f0f0f0",
                    padding: "8px 10px",
                    fontWeight: 600,
                    fontSize: "12px",
                    borderRadius: "4px",
                    gap: "6px",
                    minWidth: "700px",
                  }}
                >
                  <div>Part No</div>
                  <div>Own Accessories Name</div>
                  <div>Issue Qty</div>
                  <div>Required Qty</div>
                  <div>Mrp</div>
                  <div>Qty</div>
                  <div>HMI Amount</div>
                  <div>Own Amount</div>
                </div>
                {/* Grid row */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns:
                      "1.2fr 2fr 1fr 1fr 1fr 1fr 1.2fr 1.2fr",
                    padding: "6px 10px",
                    gap: "6px",
                    marginTop: "4px",
                    minWidth: "700px",
                  }}
                >
                  <input
                    type="text"
                    className="ch-input"
                    value={accPartNo}
                    onChange={(e) => setAccPartNo(e.target.value)}
                    style={{ fontSize: "12px", padding: "6px 8px" }}
                  />
                  <input
                    type="text"
                    className="ch-input"
                    value={accOwnName}
                    onChange={(e) => setAccOwnName(e.target.value)}
                    style={{ fontSize: "12px", padding: "6px 8px" }}
                  />
                  <input
                    type="text"
                    className="ch-input"
                    value={accIssueQty}
                    onChange={(e) => setAccIssueQty(e.target.value)}
                    style={{ fontSize: "12px", padding: "6px 8px" }}
                  />
                  <input
                    type="text"
                    className="ch-input"
                    value={accRequiredQty}
                    onChange={(e) => setAccRequiredQty(e.target.value)}
                    style={{ fontSize: "12px", padding: "6px 8px" }}
                  />
                  <input
                    type="text"
                    className="ch-input"
                    value={accMrp}
                    onChange={(e) => setAccMrp(e.target.value)}
                    style={{ fontSize: "12px", padding: "6px 8px" }}
                  />
                  <input
                    type="text"
                    className="ch-input"
                    value={accQty}
                    onChange={(e) => setAccQty(e.target.value)}
                    style={{ fontSize: "12px", padding: "6px 8px" }}
                  />
                  <input
                    type="text"
                    className="ch-input ch-amount-input"
                    value={accHMIAmount}
                    onChange={(e) => setAccHMIAmount(e.target.value)}
                    style={{ fontSize: "12px", padding: "6px 8px" }}
                  />
                  <input
                    type="text"
                    className="ch-input ch-amount-input"
                    value={accOwnAmount}
                    onChange={(e) => setAccOwnAmount(e.target.value)}
                    style={{ fontSize: "12px", padding: "6px 8px" }}
                  />
                </div>
              </div>

              {/* Summary rows */}
              <div
                className="ch-acc-summary-grid"
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr 1fr",
                  gap: "12px",
                  marginTop: "16px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    flexWrap: "wrap",
                  }}
                >
                  <label
                    style={{
                      fontSize: "12px",
                      fontWeight: 600,
                      whiteSpace: "nowrap",
                    }}
                  >
                    HMI Amount :
                  </label>
                  <input
                    type="text"
                    className="ch-input ch-readonly"
                    value={accHMIAmount}
                    readOnly
                    style={{
                      fontSize: "12px",
                      padding: "6px 8px",
                      flex: "1 1 auto",
                      minWidth: "100px",
                    }}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    flexWrap: "wrap",
                  }}
                >
                  <label
                    style={{
                      fontSize: "12px",
                      fontWeight: 600,
                      whiteSpace: "nowrap",
                    }}
                  >
                    HMI Discount Amount :
                  </label>
                  <input
                    type="text"
                    className="ch-input"
                    value={accHMIDiscountAmount}
                    onChange={(e) => setAccHMIDiscountAmount(e.target.value)}
                    style={{
                      fontSize: "12px",
                      padding: "6px 8px",
                      flex: "1 1 auto",
                      minWidth: "100px",
                    }}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    flexWrap: "wrap",
                  }}
                >
                  <label
                    style={{
                      fontSize: "12px",
                      fontWeight: 600,
                      whiteSpace: "nowrap",
                    }}
                  >
                    HMI Total Amount :
                  </label>
                  <input
                    type="text"
                    className="ch-input ch-readonly"
                    value={accHMITotalAmount}
                    readOnly
                    style={{
                      fontSize: "12px",
                      padding: "6px 8px",
                      background: "#e8f5e9",
                      flex: "1 1 auto",
                      minWidth: "100px",
                    }}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    flexWrap: "wrap",
                  }}
                >
                  <label
                    style={{
                      fontSize: "12px",
                      fontWeight: 600,
                      whiteSpace: "nowrap",
                    }}
                  >
                    OWN Amount :
                  </label>
                  <input
                    type="text"
                    className="ch-input ch-readonly"
                    value={accOWNAmount}
                    readOnly
                    style={{
                      fontSize: "12px",
                      padding: "6px 8px",
                      flex: "1 1 auto",
                      minWidth: "100px",
                    }}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    flexWrap: "wrap",
                  }}
                >
                  <label
                    style={{
                      fontSize: "12px",
                      fontWeight: 600,
                      whiteSpace: "nowrap",
                    }}
                  >
                    OWN Discount Amount :
                  </label>
                  <input
                    type="text"
                    className="ch-input"
                    value={accOWNDiscountAmount}
                    onChange={(e) => setAccOWNDiscountAmount(e.target.value)}
                    style={{
                      fontSize: "12px",
                      padding: "6px 8px",
                      flex: "1 1 auto",
                      minWidth: "100px",
                    }}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    flexWrap: "wrap",
                  }}
                >
                  <label
                    style={{
                      fontSize: "12px",
                      fontWeight: 600,
                      whiteSpace: "nowrap",
                    }}
                  >
                    OWN Total Amount :
                  </label>
                  <input
                    type="text"
                    className="ch-input ch-readonly"
                    value={accOWNTotalAmount}
                    readOnly
                    style={{
                      fontSize: "12px",
                      padding: "6px 8px",
                      background: "#e8f5e9",
                      flex: "1 1 auto",
                      minWidth: "100px",
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="ch-modal-ftr">
              <button className="ch-btn-save">Save</button>
              <button
                className="ch-btn-cancel"
                onClick={() => setShowAccessoriesModal(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      <style>{`
        *, *::before, *::after { box-sizing: border-box; }
        html, body { width: 100%; overflow-x: hidden; }

        /* ── Challan page react-select menu styles (scoped via rs__ prefix) ── */
        .rs__menu {
          background-color: #fff !important;
        }
        .rs__menu-list {
          background-color: #fff !important;
        }
        .rs__option {
          background-color: #fff !important;
          color: #333 !important;
        }
        .rs__option:active {
          background-color: #6b1530 !important;
          color: #fff !important;
        }
        .rs__option--is-focused {
          background-color: #6b1530 !important;
          color: #fff !important;
        }
        .rs__option--is-selected {
          background-color: #4a0e21 !important;
          color: #fff !important;
        }

        /* ── Page wrapper ── */
        .ch-page {
          min-height: 100vh;
          background: #f0f2f5;
          padding: 0;
          font-family: "Segoe UI", Arial, sans-serif;
        }

        /* ── Card ── */
        .ch-card {
          width: 100%;
          max-width: 100%;
          background: #fff;
          border-radius: 0;
          box-shadow: none;
          overflow: hidden;
        }

        /* ── Header ── */
        .ch-header {
          background: linear-gradient(135deg, #8B1E3F 0%, #6b1530 100%);
          color: #fff;
          text-align: center;
          font-size: 1.4rem;
          font-weight: 700;
          padding: 18px 24px;
          letter-spacing: 0.5px;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
        }
        .ch-header-icon { font-size: 1.3rem; }

        /* ── Body ── */
        .ch-body {
          padding: 24px 28px 32px;
          border: 2px solid #8B1E3F;
          border-top: none;
          border-radius: 0 0 14px 14px;
          max-height: 70vh;
          overflow-y: auto;
          overflow-x: hidden;
        }
        .ch-body::-webkit-scrollbar { width: 8px; }
        .ch-body::-webkit-scrollbar-track { background: #f1f1f1; border-radius: 4px; }
        .ch-body::-webkit-scrollbar-thumb { background: #8B1E3F; border-radius: 4px; }
        .ch-body::-webkit-scrollbar-thumb:hover { background: #6b1530; }

        /* ── Section label ── */
        .ch-section-label {
          font-size: 13px;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 1px;
          color: #fff;
          background: linear-gradient(135deg, #8B1E3F 0%, #6b1530 100%);
          padding: 9px 16px;
          border-radius: 6px;
          margin: 22px 0 14px;
          box-shadow: 0 2px 6px rgba(139,30,63,0.25);
        }
        .ch-section-label:first-child { margin-top: 0; }

        /* ── Insurance Accordion ── */
        .ch-accordion-header {
          background: #f8bcbc;
          color: #000;
          padding: 12px 15px;
          cursor: pointer;
          font-weight: bold;
          margin-top: 15px;
          border-radius: 4px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          user-select: none;
        }
        .ch-accordion-header:hover { background: #f5a8a8; }
        .ch-accordion-arrow { font-size: 12px; color: #555; }
        .ch-accordion-body {
          padding: 16px;
          border: 1px solid #ddd;
          border-top: none;
          background: #fff;
        }
        .ch-ins-topbar {
          display: flex;
          align-items: flex-end;
          gap: 24px;
          flex-wrap: wrap;
          margin-bottom: 16px;
          padding: 12px 16px;
          background: #8B1E3F;
          border-radius: 6px;
        }
        .ch-ins-radio-group {
          display: flex;
          gap: 16px;
          align-items: center;
        }
        .ch-ins-radio-group .ch-radio-label { color: #fff; }
        .ch-ins-topbar-field {
          display: flex;
          flex-direction: column;
          min-width: 160px;
        }
        .ch-ins-topbar-field .ch-label { color: #fff; font-size: 12px; }
        .ch-ins-topbar-field .ch-input { background: #fff; }
        .ch-ins-checkbox-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 10px 16px;
          padding: 12px 0;
          border-bottom: 1px solid #eee;
          margin-bottom: 8px;
        }
        .ch-ins-checkbox-label {
          display: flex;
          align-items: center;
          gap: 6px;
          font-size: 13px;
          font-weight: 500;
          cursor: pointer;
        }
        .ch-ins-checkbox-label input[type="checkbox"] {
          width: 15px;
          height: 15px;
          accent-color: #8B1E3F;
          cursor: pointer;
        }
        @media (max-width: 900px) {
          .ch-ins-checkbox-grid { grid-template-columns: repeat(2, 1fr); }
          .ch-ins-topbar { flex-direction: column; align-items: flex-start; }
        }
        @media (max-width: 600px) {
          .ch-ins-checkbox-grid { grid-template-columns: 1fr; }
        }

        /* ── Grids ── */
        .ch-grid {
          display: grid;
          gap: 16px;
          width: 100%;
        }
        .ch-grid-4  { grid-template-columns: repeat(4, 1fr); }
        .ch-grid-3  { grid-template-columns: repeat(3, 1fr); }
        .ch-grid-3w { grid-template-columns: 1fr 1fr 2fr; }

        /* ── Field ── */
        .ch-field {
          display: flex;
          flex-direction: column;
          gap: 6px;
        }

        /* ── Label ── */
        .ch-label {
          font-size: 12.5px;
          font-weight: 500;
          color: #444;
          letter-spacing: 0.2px;
        }

        /* ── Input ── */
        .ch-input {
          width: 100%;
          height: 42px;
          padding: 0 14px;
          font-size: 14px;
          font-family: "Segoe UI", Arial, sans-serif;
          border: 1.5px solid #ddd;
          border-radius: 8px;
          background: #fafafa;
          color: #333;
          transition: border-color .2s, box-shadow .2s;
          outline: none;
        }
        .ch-input::placeholder { color: #aaa; font-size: 13px; }
        .ch-input:hover  { border-color: #8B1E3F; }
        .ch-input:focus  {
          border-color: #8B1E3F;
          box-shadow: 0 0 0 3px rgba(139,30,63,.12);
          background: #fff;
        }
        .ch-readonly {
          background: #f2f2f2 !important;
          color: #666;
          font-weight: 600;
          cursor: not-allowed;
        }

        /* ── Select + add-button row ── */
        .ch-with-btn {
          display: flex;
          gap: 8px;
          align-items: center;
        }
        .ch-with-btn > div:first-child { flex: 1; min-width: 0; }

        .ch-add-btn {
          flex-shrink: 0;
          width: 42px;
          height: 42px;
          border-radius: 8px;
          border: none;
          background: #8B1E3F;
          color: #fff;
          font-size: 22px;
          line-height: 1;
          cursor: pointer;
          transition: background .2s, transform .15s;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .ch-add-btn:hover { background: #6b1530; transform: scale(1.05); }

        /* ── Modal overlay ── */
        .ch-overlay {
          position: fixed;
          inset: 0;
          background: rgba(0,0,0,.45);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 999999;
          overflow-y: auto;
          padding: 20px 0;
        }
        .ch-modal {
          width: 480px;
          max-width: 95vw;
          max-height: 90vh;
          background: #fff;
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 0 12px 40px rgba(0,0,0,.25);
          display: flex;
          flex-direction: column;
          margin: auto;
          min-height: 200px;
        }
        .ch-modal-hdr {
          background: linear-gradient(135deg, #8B1E3F, #6b1530);
          color: #fff;
          padding: 14px 20px;
          font-weight: 700;
          font-size: 15px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-shrink: 0;
        }
        .ch-modal-x {
          background: none;
          border: none;
          color: #fff;
          font-size: 18px;
          cursor: pointer;
          padding: 2px 6px;
          border-radius: 4px;
          transition: background .2s;
        }
        .ch-modal-x:hover { background: rgba(255,255,255,.15); }
        .ch-modal-body {
          padding: 20px;
          display: flex;
          flex-direction: column;
          gap: 14px;
          overflow-y: auto;
          overflow-x: hidden;
          flex: 1;
          min-height: 0;
        }
        .ch-modal-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 14px;
        }
        .ch-modal-ftr {
          display: flex;
          justify-content: center;
          gap: 12px;
          flex-shrink: 0;
          padding: 16px 20px;
          border-top: 1px solid #eee;
        }
        .ch-btn-save {
          padding: 9px 28px;
          background: #8B1E3F;
          color: #fff;
          border: none;
          border-radius: 8px;
          font-weight: 600;
          font-size: 14px;
          cursor: pointer;
          transition: background .2s;
        }
        .ch-btn-save:hover { background: #6b1530; }
        .ch-btn-cancel {
          padding: 9px 28px;
          background: #f0f0f0;
          color: #555;
          border: none;
          border-radius: 8px;
          font-weight: 600;
          font-size: 14px;
          cursor: pointer;
          transition: background .2s;
        }
        .ch-btn-cancel:hover { background: #e0e0e0; }

        /* ── Responsive ── */
        @media (max-width: 1100px) {
          .ch-grid-4 { grid-template-columns: repeat(2, 1fr); }
        }
        @media (max-width: 900px) {
          .ch-grid-3w { grid-template-columns: 1fr 1fr; }
          .ch-col-wide { grid-column: 1 / -1; }
          .ch-grid-3  { grid-template-columns: 1fr 1fr; }
          .ch-grid-3 .ch-field:last-child { grid-column: 1 / -1; }
          
          /* Payment grid horizontal scroll */
          .ch-payment-grid-wrapper {
            -webkit-overflow-scrolling: touch;
          }
        }
        @media (max-width: 768px) {
          /* Other Details section 2-column layout → single column */
          .ch-other-details-grid {
            grid-template-columns: 1fr !important;
            gap: 14px !important;
          }
          /* Final Summary section 2-column layouts → single column */
          .ch-summary-amounts-grid,
          .ch-summary-remarks-grid {
            grid-template-columns: 1fr !important;
            gap: 14px !important;
          }
          /* Sot field flex layout → stack vertically */
          .ch-sot-flex {
            flex-direction: column !important;
          }
          .ch-sot-flex select,
          .ch-sot-flex input {
            width: 100% !important;
          }
          
          /* Modal adjustments for tablets */
          .ch-modal {
            max-height: 85vh;
          }
          
          /* Accessories modal summary grid → 2 columns */
          .ch-acc-summary-grid {
            grid-template-columns: 1fr 1fr !important;
          }
        }
        @media (max-width: 600px) {
          .ch-body    { padding: 16px; }
          .ch-grid-4  { grid-template-columns: 1fr; }
          .ch-grid-3w { grid-template-columns: 1fr; }
          .ch-col-wide { grid-column: auto; }
          .ch-grid-3  { grid-template-columns: 1fr; }
          .ch-grid-3 .ch-field:last-child { grid-column: auto; }
          .ch-header  { font-size: 1.1rem; padding: 14px; }
          .ch-modal-grid { grid-template-columns: 1fr; }
          
          /* Modal adjustments for mobile */
          .ch-overlay {
            padding: 5px 0;
            align-items: flex-start;
          }
          .ch-modal {
            max-height: 96vh;
            max-width: 98vw;
            margin-top: 5px;
            margin-bottom: 5px;
          }
          .ch-modal-body {
            padding: 14px;
          }
          .ch-modal-ftr {
            padding: 12px 14px;
          }
          
          /* Accessories modal summary grid → single column */
          .ch-acc-summary-grid {
            grid-template-columns: 1fr !important;
            gap: 10px !important;
          }
          
          /* Accessories modal summary fields - stack label and input */
          .ch-acc-summary-grid > div {
            flex-direction: column !important;
            align-items: flex-start !important;
          }
          .ch-acc-summary-grid > div input {
            width: 100% !important;
          }
        }
        @media (max-width: 400px) {
          .ch-page  { padding: 10px 8px; }
          .ch-input { font-size: 13px; }
          
          /* Very small screens (iPhone SE) */
          .ch-overlay {
            padding: 2px 0;
          }
          .ch-modal {
            max-height: 98vh;
            border-radius: 8px;
          }
          .ch-modal-hdr {
            padding: 10px 14px;
            font-size: 14px;
          }
          .ch-modal-body {
            padding: 10px;
            gap: 10px;
          }
          .ch-modal-ftr {
            padding: 10px;
          }
        }
        @media (max-height: 667px) {
          /* Short screens (iPhone SE height: 667px) */
          .ch-modal {
            max-height: 98vh !important;
          }
          .ch-overlay {
            padding: 2px 0 !important;
            align-items: flex-start !important;
          }
        }

        /* ── Radio group ── */
        .ch-radio-group {
          display: flex;
          gap: 20px;
          align-items: center;
          height: 42px;
          padding: 0 4px;
        }
        .ch-radio-label {
          display: flex;
          align-items: center;
          gap: 6px;
          font-size: 13px;
          font-weight: 500;
          color: #333;
          cursor: pointer;
          user-select: none;
        }
        .ch-radio-label input[type="radio"] {
          accent-color: #8B1E3F;
          width: 15px;
          height: 15px;
          cursor: pointer;
        }

        /* ── Amount input – right-aligned value ── */
        .ch-amount-input {
          text-align: right;
          font-weight: 600;
          background: #f5f5f5 !important;
          color: #333;
        }

        /* ── Shared utility classes used by other pages ── */
        .next-btn-imd    { background:#8B1E3F;color:#fff;border:none;padding:9px 24px;border-radius:8px;font-weight:600;cursor:pointer;transition:.2s; }
        .next-btn-imd:hover { background:#6b1530; }
        .exit-btn-imd    { background:#ab2025;color:#fff;border:none;padding:9px 24px;border-radius:8px;font-weight:600;cursor:pointer;transition:.2s; }
        .exit-btn-imd:hover { background:#8e1a1f; }
        .approve-btn-imd { background:#28a745;color:#fff;border:none;padding:9px 24px;border-radius:8px;font-weight:600;cursor:pointer;transition:.2s; }
        .approve-btn-imd:hover { background:#1e7e34; }
      `}</style>
    </Layout>
  );
};

export default ChallanDetailsDesign;
